import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Autocomplete,
  FormControl, 
  FormHelperText,
  Box,
  Button,
  Card,
  Checkbox,
  CircularProgress,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Modal,
  Select,
  TextField,
  OutlinedInput
} from "@mui/material";
// import Autocomplete from '@mui/material/Autocomplete';
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import Layout from "components/structure/Layout";
import { AuthData } from "auth/AuthWarpper";
import "./Questionnare.css";
import QuestionnareService from "services/QuestionnareService";
import CommonService from "services/CommonService";
import SearchIcon from "@mui/icons-material/Search";
import CheckboxTick from "assets/CheckboxTick.svg";
import CheckboxUntick from "assets/CheckboxUntick.svg";
import { SnackbarContext } from "context/snackBarContext";
import { debounceCustom, validateForm } from "utils/CommonFunction";
import { equalsIgnoreCase, includesIgnoreCase } from "utils/utils";
import DropdownModal from "./DropdownModal";
import SeasonRegistrationService from "services/SeasonRegistrationService";
import Warning from "assets/Warning.svg";
import SurityModal from "utils/SurityModal/SurityModal";
import ClearIcon from '@mui/icons-material/Clear';
import AccessDeniedPage from './AccessDeniedPage';
import AuditConfirmModal from "./AuditConfirmModal";
// Pre-load the warning icon
const warningIcon = new Image();
warningIcon.src = Warning;
let setOriginalQuestionSequence = 0;
let setStaticFormValue = {};
let setIncomingQuestionSequence = "";
const optionsTEST = [
  { questionCode: "Code1", id: 1 },
  { questionCode: "Code2", id: 2 },
  { questionCode: "Code3", id: 3 },
];
const transparentDisabledStyle = {
  '& .MuiOutlinedInput-root': {
    '&.Mui-disabled': {
      '& fieldset': {
        borderColor: 'rgba(0, 0, 0, 0)',
        '&:hover': {
          borderColor: 'rgba(0, 0, 0, 0)',
        },
      },
    },
  },
};

// Helper function to get submodule countries
const getSubmoduleCountries = (msData, moduleId, subModuleId) => {
  const selectedModule = msData?.modules?.find(
    module => module.moduleId === moduleId
  );
  const selectedSubmodule = selectedModule?.subModules?.find(
    sub => sub.subModuleId === subModuleId
  );

  if (selectedSubmodule?.subModuleCountryLinks) {
    return selectedSubmodule.subModuleCountryLinks.map(country => ({
      countryId: country.countryId,
      countryName: country.countryName,
      countryCode: country.countryCode
    }));
  }
  return [];
};

const QuestionnareEdit = () => {
  const [searchParams] = useSearchParams();
  const location = useLocation();
   const readonlyuser = location?.state?.read_only_user || false;
  const navigate = useNavigate();
    const textFieldRef = useRef(null);
  
  // const { user } = AuthData();
  const user = JSON.parse(sessionStorage.getItem('BAT_USER'))
 let isGlobalUser=user?.userAttribute == "Global"

  const [loading, setLoading] = useState(false);
  const [countries, setCountries] = React.useState([]);
  const [modules, setModules] = useState([]);
  const [subModules, setSubModules] = useState([]);
  const [cropYears, setCropYears] = useState([]);
  const [cropStages, setCropStages] = useState([]);
  const [questionCode, setQuestionCode] = useState("");
  const [questionSequence, setQuestionSequence] = useState("");
  const [pickListData, setPickListData] = useState();
  const [questionData, setQuestionData] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const [selected, setSelected] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [mode, setMode] = useState("Add");
  const [openModal, setOpenModal] = useState(false);
  const [isMultiSelect, setIsMultiSelect] = useState(false);
  const [modalRows, setModalRows] = useState([]);
  const [promptMandatory, setPromptMandatory] = useState(false);
  const [parentMandatory, setParentMandatory] = useState(false);
  const [parentCode, setParentCode] = useState(false);
  const [responseType, setResponseType] = useState("");
  const [calculationFields, setCalculationFields] = useState({
    isCalculated: false,
    referenceQuestions: [], // This will store full question objects
    sequencedRefQuestions: [], // Store {refQuestionId, sequence} objects
    operation: "",
    expectedResult: "",
    expression: "" // Add this new field
  });
  const [calculationOperations, setCalculationOperations] = useState([
    { id: "+", label: "+" },
    { id: "-", label: "-" },
    { id: "/", label: "/" },
    { id: "*" , label: "*"}
  ]);
  const [calculationReferenceQuestions, setCalculationReferenceQuestions] = useState([]);
  const { setOpenAlert, setSeverity, setMessage } =
    React.useContext(SnackbarContext);
  const [surityModalOpen, setSurityModalOpen] = React.useState(false);
  const [surityModalOpen2, setSurityModalOpen2] = React.useState(false);
  const [surityModalMessage, setSurityModalMessage] = React.useState("");
  const   [deactivateWarningModal, setDeactivateWarningModal] = React.useState(true);
  const [clearWarningModal, setClearWarningModal] = useState(false);
  const [fieldToClear, setFieldToClear] = useState(null);
  const [hasShownWarning, setHasShownWarning] = useState(false);
  const [showAccessDenied, setShowAccessDenied] = useState(false);
  const [selectedParentOption, setSelectedParentOption] = useState(null);
  const [parentResponseOptions, setParentResponseOptions] = useState([]);
  const [openAuditConfirmModal, setOpenAuditConfirmModal] = useState(false);
  const [activeQuestion, setActiveQuestion] = useState(true);
  const [questionType, setQuestionType] = useState("");
  const [auditEvent, setAuditEvent] = useState(null)
  const [textFieldWidth, setTextFieldWidth] = useState(null);

  const [formValues, setFormValues] = React.useState({
    cropYear: {
      value: "",
      error: false,
      errorMessage: "You must select crop year",
    },
    cropStage: {
      value: "",
      error: false,
      errorMessage: "You must select crop stage",
    },
    moduleName: {
      value: "",
      error: false,
      errorMessage: "You must select module name",
    },
    subModuleName: {
      value: "",
      error: false,
      errorMessage: "You must select sub module name",
    },
    country: {
      value: "",
      error: false,
      errorMessage: "You must select country",
    },
    questionCode: {
      value: "",
      error: false,
      errorMessage: "You must provide question code",
    },
    questionType: {
      value: "",
      error: false,
      errorMessage: "You must provide question type",
    },
    questionSequence: {
      value: "",
      error: false,
      errorMessage: "You must provide question sequence",
    },
    responseType: {
      value: "",
      error: false,
      errorMessage: "You must provide response type",
    },
    mandatory: {
      value: "false",
      error: false,
      errorMessage: "",
    },
    audit: {
      value: "false",
      error: false,
      errorMessage: "",
    },
    active: {
      value: "true",
      error: false,
      errorMessage: "",
    },
    multiInstance: {
      value: "false",
      error: false,
      errorMessage: "",
    },

    promptAction: {
      value: "",
      error: false,
      errorMessage: "You must select prompt action",
    },
    promptActionReponseCondition: {
      value: "",
      error: false,
      errorMessage: "You must select prompt action response condition",
    },
    promptActionReponseValue: {
      value: "",
      error: false,
      errorMessage: "You must select prompt action response value",
    },
    parentQuestion: {
      value: "",
      error: false,
      errorMessage: "You must provide parent question",
    },
    parentCondition: {
      value: "",
      error: false,
      errorMessage: "You must select parent condition",
    },
    parentReponseValue: {
      value: "",
      error: false,
      errorMessage: "You must provide parent response value",
    },
    questionText: {
      value: "",
      error: false,
      errorMessage: "You must provide question text",
    },
    minTolerance: {
      value: "",
      error: false,
      errorMessage: "You must provide minimum value",
    },
    maxTolerance: {
      value: "",
      error: false,
      errorMessage: "You must provide maximum value",
    },
    referenceQuestion: {
      value: "",
      error: false,
      errorMessage: "",
    },
    validationType: {
      value: "",
      error: false,
      errorMessage: "",
    },
    cropStageNameLL: {
      value: "",
      error: false,
      errorMessage: "",
    },
    moduleNameLL: {
      value:  "",
      error: false,
      errorMessage: "",
    },
    subModuleNameLL: {
      value: "",
      error: false,
      errorMessage: "",
    },
    questionTextLL: {
      value: "",
      error: false,
      errorMessage: "",
    },
    isCalculated:{
      value: "false",
      error: false,
      errorMessage: "",
    },
    isValidatedQuestion:{
      value: "false",
      error: false,
      errorMessage: "",
    },
    isChildQuestion:{
      value: "false",
      error: false,
      errorMessage: "",
    }
  });
  const [valueTEST, setValue] = useState();
  const [referenceQuestions, setReferenceQuestions] = useState([]);
  const { id } = useParams();

  // Add these state variables
  const [mandatoryCountries, setMandatoryCountries] = useState([]);
  const [auditCountries, setAuditCountries] = useState([]);
  const [activeCountries, setActiveCountries] = useState([]);
  const [promptActionCountries, setPromptActionCountries] = useState([]);
  const [selectedCountries, setSelectedCountries] = useState([]);
  const [submoduleCountries, setSubmoduleCountries] = useState([]);

  useEffect(() => {
    // Update default value if options change or if defaultOption changes
    const defaultOption = optionsTEST.find((option) => option.id == 2); // Default to 'Code2'
    setValue(defaultOption);
  });
  //Initial fetch
  useEffect(() => {
    if (id) {
      if(user?.userAttribute == "Global"){
        setShowAccessDenied(true); // Set this instead of navigating
        return; // Exit early
      }
      console.log('ID from URL:', id);
      setMode("View");
      location.state = {
        ...location.state,
        QuestionId: id,
        mode: "View"
      };
    } else {
      setMode(location?.state?.mode || "Add");
    }
    if(id){
      setTimeout(()=>{
        fetchDataSequentially();
      },1000)
    }else{
      fetchDataSequentially()
    }
    
  }, []);
  const fetchDataSequentially = async () => {
    try {
      const data1 = await FetchYearAndStages();
      const plData = await fetchPickList();
      let qData = await fetchQuestionById(
        location?.state?.QuestionId,
        plData
      );
      if(qData?.countryList == undefined || qData?.countryList == null) {
      Object.assign(qData, {countryList: []}); // Ensure countryList is initialized
      }
      await fetchReferenceQuestions(qData?.cropYearId);
      const msData = await FetchModSub(
        qData?.cropYearId,
        qData?.moduleInfoResponseDto?.cropStageId
      );
      const calData = await getReferenceQuestionsCalculation(qData?.cropYearId, qData?.moduleInfoResponseDto?.cropStageId);
      if (includesIgnoreCase(qData?.responseType, ["Integer", "Numeric"])) {
        // Add this code to prefill calculation fields
        // Get the reference questions from calculationReferenceQuestions that match the refQuestions
        const selectedRefQuestions = calData?.filter(q =>
          qData?.refQuestions?.some(rq => rq.refQuestionId === q.questionId)
        );
        // Create sequencedRefQuestions array from the API data
        const sequencedQuestions = qData?.refQuestions?.map(rq => ({
          refQuestionId: rq?.refQuestionId,
          sequence: rq?.sequence
        }));
        // Generate expression based on question codes and operator
        const expression = selectedRefQuestions
          .sort((a, b) => {
            const seqA = qData.refQuestions.find(rq => rq.refQuestionId === a.questionId)?.sequence || 0;
            const seqB = qData.refQuestions.find(rq => rq.refQuestionId === b.questionId)?.sequence || 0;
            return seqA - seqB;
          })
          .map(q => q.questionCode)
          .join(` ${qData.calOperator} `);
        setCalculationFields({
          isCalculated: qData.isCalculated || false,
          referenceQuestions: selectedRefQuestions,
          sequencedRefQuestions: sequencedQuestions,
          operation: qData.calOperator || "",
          expectedResult: expression || "",
          expression: expression || ""
        });
      }
      const index = msData?.modules.findIndex(
        (item) => item.moduleId === qData.moduleInfoResponseDto?.moduleId
      );
      setSubModules(msData?.modules[index]?.subModules);
      let questionTypeId = getPickListIdFromDescription(
        "EQSTYP",
        qData?.questionType,
        plData
      );
      let responseTypeId = getPickListIdFromDescription(
        "ERSPTYP",
        qData?.responseType,
        plData
      );
      const canonicalResponseType =
        getPickListDescriptionFromData("ERSPTYP", responseTypeId, plData) ||
        qData?.responseType;
      setResponseType(canonicalResponseType);
      let promptActionTypeId = getPickListIdFromDescription(
        "EQPACT",
        qData?.promptActionQue,
        plData
      );
      let parcTypeId = getPickListIdFromDescription(
        "ERSPCON",
        qData?.promptActionResponseCondition,
        plData
      );
      let pcTypeId = getPickListIdFromDescription(
        "ERSPCON",
        qData?.parentResponseCond,
        plData
      );
      if (equalsIgnoreCase(qData?.questionType, "Dependant")) {
        setParentMandatory(true);
        setParentCode(qData?.parentQuestionCode);
      } else {
        setParentMandatory(false);
      }
      if (
        includesIgnoreCase(qData?.responseType, [
          "Dropdown",
          "Multi Select Dropdown",
          "Numeric",
          "Integer",
          "Radio Button (Yes / No)",
        ])
      ) {
        setPromptMandatory(true);
      } else {
        setPromptMandatory(false);
      }
      if(includesIgnoreCase(qData?.responseType, ["Dropdown", "Text Field", "Integer", "Date", "Geo-Location", "Numeric"])){
        setIsMultiSelect(true)
     }else{
        setIsMultiSelect(false)
     }
      setIncomingQuestionSequence = qData?.questionSequence;

      const submoduleCountries = getSubmoduleCountries(
        msData, 
        qData?.moduleInfoResponseDto?.moduleId,
        qData?.moduleInfoResponseDto?.subModuleId
      );

      // Set all available countries from submodule as options
      setCountries(submoduleCountries);

      // Convert question's selected countries to correct format and set as selected
      const selectedOptions = qData?.countryList?.map(country => ({
        countryId: country.countryCode,
        countryName: country.countryName,
        countryCode: country.countryCode
      })) || [];

      // Set selected countries
      setSelected(selectedOptions);
      setQuestionCode(qData?.questionCode);
      // setParentCode(qData?.questionCode)
      // console.log('resType1' , qData?.standardResponseDto)

      if (
        qData?.standardResponseDto != undefined &&
        qData?.standardResponseDto?.length > 0
      ) {
        let m = [];
        qData?.standardResponseDto?.map((ele, index) => {
          let obj = {
            name: ele?.stResponseEN,
            id: index,
            hlcId: index,
            stResponseId: ele?.stResponseId,
            seq: ele?.stResponseSequence,
            isPriority: ele?.stPriorityResponse,
            responseCode: ele?.responseCode,
            stResponseLL: ele?.stResponseLL,
            isMandatory: ele?.stMandatory, // Use from API
            isActive: ele?.stMandatory, // Use same value for consistency
            stMandatory: ele?.stMandatory, // Use from API
            mandatoryFlagDisable: ele?.mandatoryFlagDisable, // Add from API
          };
          console.log(isGlobalUser, obj,"global and Obj")
          m.push(obj);
        });
        console.log(m,"Object")
        let sortedData = [];
        if (m && m?.length > 0)
          sortedData = [...m].sort((a, b) => a.seq - b.seq);
        setModalRows(sortedData);
      }
      let parentResponseText = qData.parentResponse;
    let parentQuestionOption = null;
    
    if (equalsIgnoreCase(qData?.questionType, "Dependant") && qData?.parentQuestionId) {
      try {
        // Fetch parent question details
    
    // const searchDebonce = searchParent(inputValue);
        
        const parentQuestionRes = await fetchParentQuestions(
          qData?.cropYearId,
          qData?.moduleInfoResponseDto?.cropStageId,
          qData?.parentQuestionCode
        );
     
        const parentRespType = parentQuestionRes[0]?.responseType;
        
        // Create parent question option object
        parentQuestionOption = {
          questionId: qData.parentQuestionId,
          questionCode: qData.parentQuestionCode,
          responseType: parentRespType,
          parentResponseList: parentQuestionRes[0]?.parentResponseList?.map(resp => ({
            parentResponseText: resp.parentResponseText,
            parentResponseCode: resp.parentResponseCode
          })) || []
        };
        
        // Set parent response options
        setParentResponseOptions(parentQuestionOption.parentResponseList);
        setSelectedParentOption(parentQuestionOption);
        
        // Convert parent response code to text for display
        const isSelectableType = includesIgnoreCase(parentRespType, ["Dropdown", "Multi Select Dropdown", "Radio Button (Yes / No)"]);
        
        if (isSelectableType && Array.isArray(parentQuestionOption.parentResponseList)) {
          if (includesIgnoreCase(parentRespType, ["Multi Select Dropdown", "Dropdown"])) {
            // Handle multiple values
            const parentCodes = qData.parentResponse?.split('|') || [];
            const matchedOptions = parentQuestionOption.parentResponseList.filter(opt => 
              parentCodes.includes(opt.parentResponseCode)
            );
            parentResponseText = matchedOptions.map(opt => opt.parentResponseText).join('|');
          } else {
            // Handle single value
            const matchedOption = parentQuestionOption.parentResponseList.find(opt => 
              opt?.parentResponseCode == qData?.parentResponse
            );
            parentResponseText = matchedOption?.parentResponseText || qData.parentResponse;



          }
        }
      } catch (err) {
        console.warn("Failed to fetch parent question for response text mapping:", err);
      }
    }

       let promptActionResponseValue = "";
    
    if (qData?.promptActionRes) {
      if (includesIgnoreCase(qData?.responseType, ["Multi Select Dropdown", "Dropdown"])) {
        // For dropdown types, convert response codes to stResponseIds
        const responseCodes = qData.promptActionRes.split('|');
        const matchedIds = [];
        
        responseCodes.forEach(code => {
          const matchedRow = qData?.standardResponseDto?.find(
            row => row.responseCode === code
          );
          if (matchedRow) {
            matchedIds.push(matchedRow.stResponseId);
          }
        });
        
        promptActionResponseValue = matchedIds.join('|');
      } else {
        // For other types (Radio Button, Text), use the value directly
        promptActionResponseValue = qData?.promptActionRes;
      }
    }
      setFormValues((pre) => ({
        cropYear: {
          value: qData.cropYearId || "",
          error: false,
          errorMessage: "You must select crop year",
        },
        cropStage: {
          value: qData.moduleInfoResponseDto?.cropStageId || "",
          error: false,
          errorMessage: "You must select crop stage",
        },
        moduleName: {
          value: qData.moduleInfoResponseDto?.moduleId || "",
          error: false,
          errorMessage: "You must select module name",
        },
        subModuleName: {
          value: qData.moduleInfoResponseDto?.subModuleId || "",
          error: false,
          errorMessage: "You must select sub module name",
        },
        country: {
          // value: qData.country?.countryCode || "",
          value: selectedOptions || "",
          error: false,
          errorMessage: "You must select country",
        },
        questionCode: {
          value: qData.questionCode || "",
          error: false,
          errorMessage: "You must provide question code",
        },
        questionType: {
          value: questionTypeId,
          error: false,
          errorMessage: "You must provide question type",
        },
        questionSequence: {
          value: qData.questionSequence || "",
          error: false,
          errorMessage: "You must provide question sequence",
        },
        responseType: {
          value: responseTypeId || "",
          error: false,
          errorMessage: "You must provide response type",
        },
        mandatory: {
          value: qData.mandatory || false,
          error: false,
          errorMessage: "",
        },
        audit: {
          value: qData.audit || false,
          error: false,
          errorMessage: "",
        },
        active: {
          value: qData.active || false,
          error: false,
          errorMessage: "",
        },
        multiInstance: {
          value: qData.multiInstance || false,
          error: false,
          errorMessage: "",
        },

        promptAction: {
          value: promptActionTypeId,
          error: false,
          errorMessage: "You must select prompt action",
        },
        promptActionReponseCondition: {
          value: parcTypeId,
          error: false,
          errorMessage: "You must select prompt action response condition",
        },
        promptActionReponseValue: {
          value: promptActionResponseValue,
          error: false,
          errorMessage: "You must select prompt action response value",
        },
        parentQuestion: {
          value: qData?.parentQuestionId,
          error: false,
          errorMessage: "You must provide parent question",
        },
        parentCondition: {
          value: pcTypeId,
          error: false,
          errorMessage: "You must select parent condition",
        },
        parentReponseValue: {
          value: parentResponseText,
          error: false,
          errorMessage: "You must provide parent response value",
        },
        questionText: {
          value: qData.questionText || "",
          error: false,
          errorMessage: "You must provide question text",
        },
        minTolerance: {
          value:
            qData.minTolerance !== null && qData.minTolerance !== undefined
              ? qData.minTolerance
              : "",
          error: false,
          errorMessage: "You must provide minimum value",
        },
        maxTolerance: {
          value:
            qData.maxTolerance !== null && qData.maxTolerance !== undefined
              ? qData.maxTolerance
              : "",
          error: false,
          errorMessage: "You must provide maximum value",
        },
        isPrePopulated: {
          value: qData.isPrePopulated !== null && qData.isPrePopulated !== undefined ? qData.isPrePopulated : false,
          error: false,
          errorMessage: ""
        },
        referenceQuestion: {
          value: qData?.referenceQuestionId || "",
          error: false,
          errorMessage: "",
        },
        validationType: {
          value: getPickListIdFromDescription(
            "EQREFQV",
            qData?.validationRule,
            plData
          ) || "",
          error: false,
          errorMessage: "",
        },
        cropStageNameLL: {
          value: qData?.moduleInfoResponseDto?.cropStageNameLL || "",
          error: false,
          errorMessage: "",
        },
        moduleNameLL: {
          value: qData?.moduleInfoResponseDto?.moduleNameLL || "",
          error: false,
          errorMessage: "",
        },
        subModuleNameLL: {
          value: qData?.moduleInfoResponseDto?.subModuleNameLL || "",
          error: false,
          errorMessage: "",
        },
        questionTextLL: {
          value: qData?.questionTextLL || "",
          error: false,
          errorMessage: "",
        },
        isCalculated:{
          value: qData?.isCalculated,
          error: false,
          errorMessage: "",
        },
        isValidatedQuestion:{
          value: qData?.isValidatedQuestion,
          error: false,
          errorMessage: "",
        },
        isChildQuestion:{
          value: qData?.isChildQuestion,
          error: false,
          errorMessage: "",
        }
      }));

      // Convert selected countries format
      const selectedCountriesFromData = qData?.countryList?.map(country => ({
        countryId: country.countryCode,
        countryName: country.countryName,
        countryCode: country.countryCode
      })) || [];

      // Set main country dropdown selected values
      setSelected(selectedCountriesFromData);
      setSelectedCountries(selectedCountriesFromData);

      // Get country IDs from flags
      const mandatoryCountryIds = qData?.mandatoryFlag?.countryIds || [];
      const auditCountryIds = qData?.auditFlagValue?.countryIds || [];
      const activeCountryIds = qData?.activeFlag?.countryIds || [];
      const promptActionCountryIds = qData?.promptActionValue?.countryIds || [];

      // Initialize checkbox dropdowns with filtered countries from selected countries
      setMandatoryCountries(
        selectedCountriesFromData.filter(country => 
          mandatoryCountryIds.includes(country.countryId)
        )
      );

      setAuditCountries(
        selectedCountriesFromData.filter(country => 
          auditCountryIds.includes(country.countryId)
        )
      );

      setActiveCountries(
        selectedCountriesFromData.filter(country => 
          activeCountryIds.includes(country.countryId)
        )
      );

      setPromptActionCountries(
        selectedCountriesFromData.filter(country => 
          promptActionCountryIds.includes(country.countryId)
        )
      );
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  //effect to search parent question on input change
  useEffect(() => {
    // fetchParentQuestions(inputValue);
  }, [inputValue]);

  // 1. Core async function
const fetchParentQuestions = async (cropYearId, cropStageId, parentCode) => {
  const params = new URLSearchParams();
  params.append("cropYear", cropYearId);
  params.append("cropStage", cropStageId);
  params.append("userInput", parentCode);

  setLoading(true);
  try {
    const res = await QuestionnareService.SearchParent({ params });
    const data = res?.data?.response?.questions;
    setOptions(data);
    return data;
  } catch (ex) {
    console.log("error", ex);
    return null;
  } finally {
    setLoading(false);
  }
};

// 2. Debounced version for inputs
const searchParent = useCallback(debounceCustom(fetchParentQuestions, 1000), []);

  
  const FetchYearAndStages = async () => {
    return new Promise((resolve, reject) => {
      setLoading(true);
      QuestionnareService.FetchDropdown()
        .then((res) => {
          setLoading(false);
          let data = res?.data?.response;
          // setCropYears(data?.cropYearResponse)
          FetchCropYears();
          setCropStages(data?.cropStageResponse);
          resolve(data);
        })
        .catch((ex) => {
          console.log("error", ex);
          setLoading(false);
        });
    });
  };
  const FetchCropYears = () => {
    setLoading(true);
    SeasonRegistrationService.getCropYears()
      .then((res) => {
        setLoading(false);
        let data = res?.data?.response;
        const formattedYear = data?.map(({ cropYear, ...rest }) => ({
          cyCropYear: cropYear,
          ...rest,
        }));
        setCropYears(formattedYear);
      })
      .catch((ex) => {
        console.log("error", ex);
        setLoading(false);
      });
  };
  const FetchModSub = (cropYearId, cropStageId) => {
    return new Promise((resolve, reject) => {
      setLoading(true);
      QuestionnareService.FetchModSub({ cropYearId, cropStageId })
        .then((res) => {
          setLoading(false);
          let data = res?.data?.response;
          
          // Get the selected module and submodule
          const selectedModule = data?.modules?.find(
            module => module.moduleId === formValues?.moduleName?.value
          );
          const selectedSubmodule = selectedModule?.subModules?.find(
            sub => sub.subModuleId === formValues?.subModuleName?.value
          );
  
          // Get all available countries from submodule
          const submoduleCountries = selectedSubmodule?.subModuleCountryLinks?.map(country => ({
            countryId: country.countryId,
            countryName: country.countryName,
            countryCode: country.countryCode
          })) || [];
  
          // Set all available countries in the dropdown
          setCountries(submoduleCountries);
  
          setModules(data?.modules);
          resolve(data);
        })
        .catch((ex) => {
          console.log("error", ex);
          setLoading(false);
        });
    });
  };

  const fetchPickList = async () => {
    return new Promise((resolve, reject) => {
      setLoading(true);
      CommonService.fetchPickList({
        pickListCodes: ["EQSTYP", "EQPACT", "ERSPCON", "ERSPTYP", "EQREFQV"],
      })
        .then((res) => {
          setLoading(false);
          let data = res?.data?.response;
          setPickListData(data);
          resolve(data);
        })
        .catch((ex) => {
          console.log("error", ex);
          setLoading(false);
        });
    });
  };
  const fetchQuestionById = async (questionId, plData) => {
    return new Promise((resolve, reject) => {
      setLoading(true);
      QuestionnareService.FetchQuestionById({ questionId })
        .then((res) => {
          setLoading(false);
          let data = res?.data?.response;
          setQuestionData(data);

          // Format countries from countryList with proper structure
          const formattedSelectedCountries = data.countryList.map(country => ({
            countryId: country.countryCode,
            countryName: country.countryName,
            countryCode: country.countryCode
          }));

          // Set selected countries
          setSelected(formattedSelectedCountries);
          setSelectedCountries(formattedSelectedCountries);

          // Add this line to capture the current published status
          const currentPublishedStatus = data.isPublished || false;

          let parentId = data?.parentQuestionId;
          if (parentId && parentId != "") {
            FetchQuestionSequence(
              data?.moduleInfoResponseDto?.moduleId
            );
          } else {
            FetchQuestionSequence(data?.moduleInfoResponseDto?.moduleId
            );
          }

          // Get validation type ID from the validation rule description
          let validationTypeId = getPickListIdFromDescription(
            "EQREFQV",
            data?.validationRule,
            plData
          );

          // Update formValues to include reference question and validation type
          setFormValues((prev) => ({
            ...prev,
            referenceQuestion: {
              value: data?.referenceQuestionId || "",
              error: false,
              errorMessage: ""
            },
            validationType: {
              value: validationTypeId || "",
              error: false,
              errorMessage: ""
            },
            isCalculated:{
              value: data?.isCalculated,
              error: false,
              errorMessage: "",
            },
            isValidatedQuestion:{
              value: data?.isValidatedQuestion,
              error: false,
              errorMessage: "",
            },
            isChildQuestion:{
              value: data?.isChildQuestion,
              error: false,
              errorMessage: "",
            }
          }));

          resolve(data);
        })
        .catch((ex) => {
          console.log("error", ex);
          setLoading(false);
        });
    });
  };

  const FetchQuestionSequence = (moduelId) => {
    setLoading(true);
    QuestionnareService.FetchQuestionSequence({ moduelId })
      .then((res) => {
        setLoading(false);
        let data = res?.data?.response;
        let dec = Number(data) - 1;
        setQuestionSequence(dec);
        setOriginalQuestionSequence = dec;
        setLoading(false);
      })
      .catch((ex) => {
        console.log("error", ex);
        setLoading(false);
      });
  };

  const handleChange = (e) => {
    let { name, value, checked } = e.target;
    const regex = /^(?!\s)(?!.*\s{2,}).*$/;
    const isValid = regex.test(value);
    if (
      name == "active" ||
      name == "mandatory" ||
      name == "audit" ||
      name == "multiInstance"
    ) {
      value = checked;
    }
    const regex2 = /^(?!\s)(?!.*\s{2,}).*$/;
    if (name == "questionSequence") {
      const numberRegex = /^[1-900000]*$/;
      const isValidNumber = numberRegex.test(value);
      if (!isValidNumber){
        setMessage("Only integer values are allowed");
        setSeverity("error");
        setOpenAlert(true);
        return
      }
      if (value > setOriginalQuestionSequence) {
        setMessage(
          `Value cannot be greater then ${setOriginalQuestionSequence}`
        );
        setSeverity("error");
        setOpenAlert(true);
        return;
      }
      if (value < setOriginalQuestionSequence) {
        if (value != "" && value != 0) {
          setMessage(
            `Question Sequence already in use. Do you still want to insert at this sequence?`
          );
          setSeverity("error");
          setOpenAlert(true);
        }
      }
      setQuestionSequence(value);
    }

    if (name == 'multiInstance' && calculationFields?.isCalculated) {
      setSurityModalMessage("This is a calculated question, not possible to be Multi instance. Please make this question as not calculated, then flag as Multi instance.");
      setSurityModalOpen(true);
      return;
    }
     // Special handling for multiInstance checkbox
  if (name === 'multiInstance' && checked === true && (formValues?.referenceQuestion?.value == "" ||formValues?.validationType?.value == "")  ) {
    // If multiInstance is being checked, directly clear reference question and validation
    let newFormValues = {
      ...formValues,
      [name]: {
        ...formValues[name],
        value,
        error: false,
        errorMessage: "",
      },
      referenceQuestion: {
        value: "",
        error: false,
        errorMessage: ""
      },
      validationType: {
        value: "",
        error: false,
        errorMessage: ""
      }
    };
    
    setFormValues(newFormValues);
    return;
  }
    if (regex2.test(value) || value === "") {
    } else {
      if (name == "email") {
      } else {
        return;
      }
    }
    const hasTrailingSpaces = !isValid;

    // Add validation for min/max values
    let newFormValues = {
      ...formValues,
      [name]: {
        ...formValues[name],
        value,
        error: hasTrailingSpaces ? true : false,
        errorMessage: hasTrailingSpaces
          ? "Trailing spaces are not allowed"
          : formValues[name]?.errorMessage,
      },
    };
    if(name == "validationType" && value == "") {
      // If validation type is changed, reset the errror message
      newFormValues.referenceQuestion = {
        value: newFormValues.referenceQuestion.value,
        error: false,
        errorMessage: "",
      };
    }
    if(name == "referenceQuestion" && value == "") {
      // If referenceQuestion is changed, reset the errror message
      newFormValues.validationType = {
        value: newFormValues.validationType.value,
        error: false,
        errorMessage: "",
      };
    }
    console.log(newFormValues)
    setFormValues(newFormValues);
    setStaticFormValue = { ...formValues };
    if (name == "responseType") {
      setResponseType(getPickListDescriptionFromData("ERSPTYP", value, pickListData) || "");
      // handleResponseType(value) // for loading modal logic
      // handlePromtMandatory(value, newFormValues) // for marking  prompt mandatory as i.e dependent on this field
    }
    if (name == "questionType") {
      // handleParentMandatory(value)
    }
  };
const handleChangeCountry = (event) => {
  const { name, value } = event.target;
  
  // Handle Select All case
  if (value === 'all') {
    // Check if all countries are already selected
    if (selected.length === countries.length) {
      // Check if any country is selected in dependent dropdowns before removing all
      const usedCountries = new Set();
      
      mandatoryCountries.forEach(country => usedCountries.add(country.countryName));
      auditCountries.forEach(country => usedCountries.add(country.countryName));
      activeCountries.forEach(country => usedCountries.add(country.countryName));
      promptActionCountries.forEach(country => usedCountries.add(country.countryName));

      if (usedCountries.size > 0) {
        setSeverity("error");
        setMessage(`This country is associated with one or more attributes. Please 
deselect the country from the attributes first, then try again.`);
        setOpenAlert(true);
        return;
      }

      setSelected([]);
      setSelectedCountries([]);
    } else {
      // Select all countries that aren't already selected
      setSelected(countries);
      setSelectedCountries(countries);
    }

    // Update form values
    setFormValues(prev => ({
      ...prev,
      country: {
        value: countries,
        errorMessage: "You must select country",
        error: false,
      },
    }));
    return;
  }
   return
  // Rest of the existing code for individual country selection
  const clickedCountry = value;
  const isSelected = selected.some(
    country => country.countryId === clickedCountry.countryId
  );

  if (isSelected) {
    // Check if country is selected in any dependent dropdown
    const isUsedInMandatory = mandatoryCountries.some(
      country => country.countryId === clickedCountry.countryId
    );
    const isUsedInAudit = auditCountries.some(
      country => country.countryId === clickedCountry.countryId
    );
    const isUsedInActive = activeCountries.some(
      country => country.countryId === clickedCountry.countryId
    );
    const isUsedInPromptAction = promptActionCountries.some(
      country => country.countryId === clickedCountry.countryId
    );

    const usedInDropdowns = [];
    if (isUsedInMandatory) usedInDropdowns.push("Mandatory");
    if (isUsedInAudit) usedInDropdowns.push("Audit");
    if (isUsedInActive) usedInDropdowns.push("Active");
    if (isUsedInPromptAction) usedInDropdowns.push("Prompt Action");

    if (usedInDropdowns.length > 0) {
      setSeverity("error");
      setMessage(`This country is associated with one or more attributes. Please 
deselect the country from the attributes first, then try again.`);
      setOpenAlert(true);
      return;
    }

    // If not used in any dependent dropdown, remove it
    const newSelection = selected.filter(
      country => country.countryId !== clickedCountry.countryId
    );
    setSelected(newSelection);
    setSelectedCountries(newSelection);
  } else {
    // Add new country
    const newSelection = [...selected, clickedCountry];
    setSelected(newSelection);
    setSelectedCountries(newSelection);
  }

  // Update form values
  setFormValues(prev => ({
    ...prev,
    [name]: {
      value: value === 'all' ? selected : value,
    },
  }));
};

const handleMandatoryCountryChange = (event) => {
  const { value } = event.target;
  if (value === 'all') {
    const newSelected = mandatoryCountries.length === selectedCountries.length ? [] : [...selectedCountries];
    setMandatoryCountries(newSelected);
  } else {
    setMandatoryCountries(value);
  }
};

const handleAuditCountryChange = (event) => {
  const { value } = event.target;
  if (value === 'all') {
    const newSelected = auditCountries.length === selectedCountries.length ? [] : [...selectedCountries]; 
    setAuditCountries(newSelected);
  } else {
    setAuditCountries(value);
  }
};

const handleActiveCountryChange = (event) => {
  const { value } = event.target;
  if (value === 'all') {
    const newSelected = activeCountries.length === selectedCountries.length ? [] : [...selectedCountries];
    setActiveCountries(newSelected);
  } else {
    setActiveCountries(value); 
  }
};

const handlePromptActionCountryChange = (event) => {
  const { value } = event.target;
  if (value === 'all') {
    const newSelected = promptActionCountries.length === selectedCountries.length ? [] : [...selectedCountries];
    setPromptActionCountries(newSelected);
  } else {
    setPromptActionCountries(value);
  }
};

// Add useEffect to sync dropdowns when main selection changes
useEffect(() => {
  // Filter out countries that are no longer in main selection
  setMandatoryCountries(prev => 
    prev.filter(country => 
      selectedCountries.some(selected => selected.countryId === country.countryId)
    )
  );

  setAuditCountries(prev =>
    prev.filter(country =>
      selectedCountries.some(selected => selected.countryId === country.countryId)  
    )
  );

  setActiveCountries(prev =>
    prev.filter(country =>
      selectedCountries.some(selected => selected.countryId === country.countryId)
    )
  );

  setPromptActionCountries(prev =>
    prev.filter(country =>
      selectedCountries.some(selected => selected.countryId === country.countryId)
    )
  );
}, [selectedCountries]);

  const getPickListDescription = (listName, pickListId) => {
    if (!pickListData) return;
    const list = pickListData[listName];
    const item = list.find((entry) => entry.pickListId === pickListId);
    return item ? item.pickListDescription : ``;
  };
  const getPickListDescriptionFromData = (listName, pickListId, plData) => {
    if (!plData) return;
    const list = plData[listName];
    const item = list.find((entry) => entry.pickListId === pickListId);
    return item ? item.pickListDescription : ``;
  };
  const getPickListIdFromDescription = (
    listName,
    pickListDescription,
    plData
  ) => {
    if (!plData) return;
    const list = plData[listName];
    const item = list.find(
      (entry) => equalsIgnoreCase(entry.pickListDescription, pickListDescription)
    );
    return item ? item.pickListId : ``;
  };

  const validateCountryDropdowns = () => {
    let errors = false;
    let message = "";
  
    // Check Active countries
    if (formValues?.active?.value && activeCountries.length === 0) {
      errors = true;
      message = "Please select countries for Active";
    }
  
    // Check Mandatory countries
    if (formValues?.mandatory?.value && mandatoryCountries.length === 0) {
      errors = true;
      message = message || "Please select countries for Mandatory";
    }
  
    // Check Audit countries
    if (formValues?.audit?.value && auditCountries.length === 0) {
      errors = true;
      message = message || "Please select countries for Audit";
    }
  
    // Check Prompt Action countries
    const promptActionValue = getPickListDescription("EQPACT", formValues?.promptAction?.value);
    if (promptActionValue !== "No" && promptActionCountries.length === 0) {
      errors = true;
      message = message || "Please select countries for Prompt Action";
    }
  
    return { errors, message };
  };

  const handleSubmit = async (e, isPublished) => {
    e.preventDefault();
  
    // Existing validation logic...
  
    // Add country dropdown validation
    if(user && user?.userAttribute == "Global"){
    const { errors, message } = validateCountryDropdowns();
    if (errors) {
      setMessage(message);
      setSeverity("error");
      setOpenAlert(true);
      return;
    }
  }
  
    // Add min/max validation check with null checks
    const responseTypeDesc = getPickListDescription(
      "ERSPTYP",
      formValues?.responseType?.value
    );
    if (includesIgnoreCase(responseTypeDesc, ["Numeric", "Integer"])) {
      const minTolerance = formValues?.minTolerance?.value
        ? parseFloat(formValues.minTolerance.value)
        : null;
      const maxTolerance = formValues?.maxTolerance?.value
        ? parseFloat(formValues.maxTolerance.value)
        : null;

      if (
        minTolerance !== null &&
        maxTolerance !== null &&
        minTolerance >= maxTolerance
      ) {
        setMessage("Minimum value must be less than maximum value");
        setSeverity("error");
        setOpenAlert(true);
        return;
      }

      // Additional validation to ensure both values are provided
      // if ((minTolerance === null && maxTolerance !== null) || (minTolerance !== null && maxTolerance === null)) {
      //     setMessage("Both minimum and maximum values must be provided");
      //     setSeverity("error");
      //     setOpenAlert(true);
      //     return;
      // }
    }

    const formFields = Object.keys(formValues);
    let newFormValues = { ...formValues };
    for (let index = 0; index < formFields.length; index++) {
      const currentField = formFields[index];
      const currentValue = formValues[currentField].value;
      if (currentValue == "" || currentValue === undefined) {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            // error: currentField == 'questionCode' ? false : true
          },
        };
      }
      if (currentField == "questionSequence") {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            // error: currentValue ? false : true,
          },
        };
      }
      if (currentField == "cropYear" && currentValue == "Crop Year") {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            // error: true,
          },
        };
      }
      if (currentField == "cropStage" && currentValue == "Crop Stage") {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            // error: true,
          },
        };
      }
      if (currentField == "moduleName" && currentValue == "Module Name") {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            // error: true,
          },
        };
      }
      if (
        currentField == "subModuleName" &&
        currentValue == "Sub Module Name"
      ) {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            // error: true,
          },
        };
      }
      if (currentField == "country" && currentValue == "Country") {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            // error: true,
          },
        };
      }
      if (currentField == "questionType" && currentValue == "Question Type") {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            // error: true,
          },
        };
      }
      if (currentField == "responseType" && currentValue == "Answer Type") {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            // error: true,
          },
        };
      }
      if (
        currentField == "active" ||
        currentField == "audit" ||
        currentField == "mandatory" ||
        currentField == "multiInstance"
      ) {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            // error: false,
          },
        };
      }
      if (currentField == "promptAction") {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            // error: false,
          },
        };
      }
      if (currentField == "promptActionReponseCondition") {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            value: currentValue == "Select Condition" ? "" : currentValue,
            // error: promptMandatory ? currentValue ? currentValue == "Select Condition" ? true : false : false,
          },
        };
      }
      if (currentField == "promptActionReponseValue") {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            // error: promptMandatory ? currentValue ? false : true : false,
          },
        };
      }
      if (currentField == "parentQuestion") {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            value: parentMandatory == false ? "" : currentValue,
            // error: parentMandatory ? currentValue == "" || currentValue == undefined ? true : false : false,
          },
        };
      }
      if (currentField == "parentCondition") {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            value: parentMandatory == false ? "" : currentValue,
            // error: parentMandatory ? currentValue == "" || currentValue == "Select Parent Condition" ? true : false : false,
          },
        };
      }
      if (currentField == "parentReponseValue") {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            value: parentMandatory ? currentValue : "", // Ensure empty if not required
            error: parentMandatory && !currentValue,
            errorMessage: "You must provide parent response",
          },
        };
      }
      if (currentField == "questionText") {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            value: currentValue.trim(),
            error: currentValue.trim() == "" ? true : false,
            errorMessage:
              currentValue.trim() == ""
                ? "You must provide question text"
                : "",
          },
        };
      }
      if(currentField == "referenceQuestion") {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            value: currentValue || "",
            error: (!formValues?.validationType?.value == ""&& currentValue == "") ? true : false,
            errorMessage: (!formValues?.validationType?.value == ""&& currentValue == "") ? "You must provide reference question for validation" : "",
          }
        };
      }
      if(currentField == "validationType") {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            value: currentValue || "",
            error: (!formValues?.referenceQuestion?.value == ""&& currentValue == "")  ? true : false,
            errorMessage: (!formValues?.referenceQuestion?.value == ""&& currentValue == "")  ? "You must provide validation" : "",
          }
        };
      }
      
    }

    let type = getPickListDescription(
      "EQSTYP",
      newFormValues?.questionType?.value
    );
    if (type == "Dependant") {
      let selectedParent = options?.find(
        (ele) => ele?.questionId == newFormValues?.parentQuestion?.value
      );
      if (
        selectedParent &&
        selectedParent?.moduleId == newFormValues?.moduleName?.value
      ) {
        if (
          newFormValues?.questionSequence?.value <=
          selectedParent?.questionSequence
        ) {
          setMessage(
            `Question Sequence should be greater than ${selectedParent?.questionSequence}`
          );
          setSeverity("error");
          setOpenAlert(true);
          return;
        }
      }
    }

    setFormValues(newFormValues);
    setStaticFormValue = { ...formValues };
    // updateQuestion(newFormValues, isPublished);
    if (validateForm(newFormValues) == true) {
      updateQuestion(newFormValues, isPublished);
    } else {
      return
    }
  };
  const updateQuestion = (newFormValues, isPublished) => {
    let standardResponseDto = [];
    let allcountryids = [];
    selectedCountries?.map((ele) => {
      allcountryids.push(ele.countryId);
    });
    let resType = getPickListDescription(
      "ERSPTYP",
      newFormValues?.responseType?.value
    );
    if (includesIgnoreCase(resType, ["Dropdown", "Multi Select Dropdown"])) {
      modalRows?.map((ele) => {
        let obj = {
          stResponseEN: ele?.name,
          stResponseSequence: ele?.seq,
          stResponseId: filterStaticId(ele?.stResponseId),
          stIsActive: true,
          stPriorityResponse: ele?.isPriority || false,
          // Ensure stMandatory is always a boolean
          stMandatory: ele?.stMandatory === true || ele?.stMandatory === "true" || ele?.stMandatory === 1
        };
        if(mode == "Edit"|| mode == "newView"){
          obj['responseCode'] = ele?.responseCode
        }if(mode == "View"){
          obj['stResponseLL'] = ele?.stResponseLL
        }
        standardResponseDto.push(obj);
      });
    }
    if (equalsIgnoreCase(resType, "Radio Button (Yes / No)")) {
      standardResponseDto = questionData?.standardResponseDto;
    }
    let parentResponse = "";
  const rawParentValue = newFormValues?.parentReponseValue?.value;
  const responseType = selectedParentOption?.responseType;

  if (includesIgnoreCase(responseType, ["Multi Select Dropdown", "Dropdown"])) {
    const selectedTexts = rawParentValue?.split("|") || [];
    const codes = parentResponseOptions
      .filter((opt) => selectedTexts.includes(opt.parentResponseText))
      .map((opt) => opt.parentResponseCode)
      .filter(Boolean);
    parentResponse = codes.join("|");
  } else if (equalsIgnoreCase(responseType, "Radio Button (Yes / No)")) {
    const matched = parentResponseOptions.find(
      (opt) => opt.parentResponseText === rawParentValue
    );
    parentResponse = matched?.parentResponseCode || rawParentValue;
  } else {
    parentResponse = rawParentValue;
  }
 
 let promptActionRes = "";
  const responseTypeDesc = getPickListDescription("ERSPTYP", newFormValues?.responseType?.value);
  
  if (includesIgnoreCase(responseTypeDesc, ["Multi Select Dropdown", "Dropdown"])) {
    // Convert stResponseIds back to response codes
    if (newFormValues?.promptActionReponseValue?.value) {
      const selectedIds = newFormValues.promptActionReponseValue.value.split('|');
      const responseCodes = [];
      
      selectedIds.forEach(id => {
        const matchedRow = modalRows?.find(row => row.stResponseId === id);
        if (matchedRow && matchedRow.responseCode) {
          responseCodes.push(matchedRow.responseCode);
        }
      });
      
      promptActionRes = responseCodes.join('|');
    }
  } else {
    // For other types, use the value directly
    promptActionRes = newFormValues?.promptActionReponseValue?.value || "";
  }

    const mandatoryFlag = {
      value: newFormValues?.mandatory?.value ? "Y" : "N",
      countryIds: mandatoryCountries.map(country => country.countryId)
    };

    const auditFlagValue = {
      value: newFormValues?.audit?.value ? "Y" : "N",
      countryIds: auditCountries.map(country => country.countryId)
    };

    const activeFlag = {
      value: newFormValues?.active?.value ? "Y" : "N",
      countryIds: activeCountries.map(country => country.countryId)
    };

    const promptActionValue = {
      value: getPickListDescription("EQPACT", newFormValues?.promptAction?.value),
      countryIds: promptActionCountries.map(country => country.countryId)
    };

    let data = {
      createdByUser: user ? user?.userName : "",
      modifiedByUser: user ? user?.userName : "",
      questionId: location?.state?.QuestionId,
      cropStage: newFormValues?.cropStage?.value,
      cropYearUid: newFormValues?.cropYear?.value,
      module: newFormValues?.moduleName?.value,
      subModule: newFormValues?.subModuleName?.value,
      language: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
      questionTextEng: newFormValues?.questionText?.value,
      questionType: getPickListDescription(
        "EQSTYP",
        newFormValues?.questionType?.value
      ),
      responseType: getPickListDescription(
        "ERSPTYP",
        newFormValues?.responseType?.value
      ),
      questionSequence: newFormValues?.questionSequence?.value,
      isQuestionSequenceEdited:
        newFormValues?.questionSequence?.value != setIncomingQuestionSequence
          ? true
          : false,
      questionInstruction: "",
      multiInstance: newFormValues?.multiInstance?.value,
      parentResponse:parentResponse ,
      isMandatory: newFormValues?.mandatory?.value,
      promptActionQue: getPickListDescription(
        "EQPACT",
        newFormValues?.promptAction?.value
      ),
      promptActionResponseCond: getPickListDescription(
        "ERSPCON",
        newFormValues?.promptActionReponseCondition?.value
      ),
      promptActionRes: promptActionRes,
      isActive: newFormValues?.active?.value,
      isPublished: mode == "View" ? questionData?.isPublished:isPublished,
      auditFlag: newFormValues?.audit?.value,
      questionCode: true,
      parentResponseCond: getPickListDescription(
        "ERSPCON",
        newFormValues?.parentCondition?.value
      ),
      parentQuestionId: newFormValues?.parentQuestion?.value,
      standardResponseDto: standardResponseDto,
      minTolerance: formValues?.minTolerance?.value || null,
      maxTolerance: formValues?.maxTolerance?.value || null,
      referenceQuestionId: newFormValues?.referenceQuestion?.value || null,
      validationRule: getPickListDescription(
        "EQREFQV",
        newFormValues?.validationType?.value
      ) || null,
    };

    if (mode !== "View") {
      data = {
        ...data,
        countryId: allcountryids,
        mandatoryFlag,
        auditFlagValue,
        activeFlag,
        promptActionValue
      };
    }

    if (includesIgnoreCase(data.responseType, ["Integer", "Numeric"])) {
      if ((calculationFields?.operation == "" || calculationFields?.operation == null)
        && (!calculationFields?.expression == "" || !calculationFields?.expression == null)
      ) {
        setMessage("Please provide calculation operation");
        setSeverity("error");
        setOpenAlert(true);
        return;
      }
      data.isCalculated = calculationFields?.isCalculated || false;
      data.calOperator = calculationFields?.operation || null;
      data.calExpression = calculationFields?.expression || null;
      const currentRefQuestions = calculationFields?.sequencedRefQuestions?.map(rq => ({
        queRefCalcId: questionData?.refQuestions?.find(x => x.refQuestionId === rq.refQuestionId)?.queRefCalcId || null,
        refQuestionId: rq.refQuestionId,
        sequence: rq.sequence,
        isDeleted: false,
        createdDateTimeUTC: null,
        createdByUser: null,
        modifiedDateTimeUTC: null,
        modifiedByUser: null
      })) || [];

      data.refQuestions = mergeAndMarkDeletedRefQuestions(currentRefQuestions, questionData?.refQuestions);
    } else if (questionData?.refQuestions?.length > 0) {
      // For non-numeric types, if there are existing reference questions, mark them all as deleted
      data.refQuestions = questionData.refQuestions.map(rq => ({
        ...rq,
        isDeleted: true
      }));
    }

    if(mode == "View"){
      data.cropStageNameLL = formValues?.cropStageNameLL?.value;
      data.moduleNameLL=formValues?.moduleNameLL?.value;
      data.subModuleNameLL=formValues?.subModuleNameLL?.value;
      data.questionTextLL=formValues?.questionTextLL?.value;
    }

    // return 
    setLoading(true);
    QuestionnareService.updateQuestion(data)
      .then((res) => {
        setLoading(false);
        navigate("/QuestionnaireSetup");
        let message = isPublished
          ? `Published successfully`
          : `Updated successfully`;
        setMessage(message);
        setSeverity("success");
        setOpenAlert(true);
      })
      .catch((ex) => {
        console.log("error", ex);
        setMessage(`Failed to update question`);
        setSeverity("error");
        setOpenAlert(true);
        setLoading(false);
      });
  };
  function filterStaticId(id) {
    if (typeof id === 'string' && id.startsWith('static')) {
      return '';
    }
    return id;
  }
  const hanldeResponseTypeClick = (a, b) => {
    let description = getPickListDescription(
      "ERSPTYP",
      formValues?.responseType?.value
    );
    if (includesIgnoreCase(description, ["Dropdown", "Multi Select Dropdown"])) {
      setOpenModal(true);
    } else {
    }
  };
  // First, add a helper function to check response type
  const isIntegerResponseType = () => {
    const responseTypeDesc = getPickListDescription(
      "ERSPTYP",
      formValues?.responseType?.value
    );
    return equalsIgnoreCase(responseTypeDesc, "Integer");
  };
  const handlePrepopulated = (e) => {
    setSurityModalMessage("The Pre-populated questions requires to inform the system developers the conditions that the response should be populated. Please ensure to create a Change Request to proper populate the answers in the mobile app, or to remove the already existing pre-population. ");
    setSurityModalOpen(true)
  }

  const fetchReferenceQuestions = (cropYearId) => {
    setLoading(true);
    QuestionnareService.FetchReferenceQuestions({ cropYearId })
      .then((res) => {
        setLoading(false);
        const data = res?.data?.response;
        setReferenceQuestions(data);
      })
      .catch((ex) => {
        console.log("error", ex);
        setLoading(false);
      });
  };

  const getReferenceQuestionsCalculation = (cropYearId, cropStageId) => {
    return new Promise((resolve, reject) => {
      let query = {
        cropYearId: cropYearId, cropStageId: cropStageId
      }
      QuestionnareService.getReferenceQuestionsCalculation(query)
        .then((res) => {
          setLoading(false);
          const data = res?.data?.response;
          setCalculationReferenceQuestions(data);
          resolve(data)
        }).catch((ex) => {
          console.log("error", ex);
          setLoading(false);
          resolve([])
        })
    });

  };

  // Add this function to generate the expression
  const generateExpression = (questions, operation) => {
    if (!questions.length) return "";
    return questions.map(q => q.questionCode).join(` ${operation} `);
  };

  // First, create a function to merge and mark deleted items
  const mergeAndMarkDeletedRefQuestions = (currentRefQuestions, previousRefQuestions) => {
    // First, remove duplicates from currentRefQuestions based on refQuestionId
    const uniqueCurrentRefQuestions = currentRefQuestions.reduce((acc, current) => {
      const exists = acc.find(item => item.refQuestionId === current.refQuestionId);
      if (!exists) {
        acc.push(current);
      }
      return acc;
    }, []);

    // Set isDeleted: false for all unique current reference questions
    const currentWithDeleted = uniqueCurrentRefQuestions.map(rq => ({
      ...rq,
      isDeleted: false
    }));

    // If there are previous questions, check for deleted ones
    if (previousRefQuestions && previousRefQuestions.length > 0) {
      // Find items in previous that are not in current and mark them as deleted
      const deletedItems = previousRefQuestions
        .filter(prev => !uniqueCurrentRefQuestions.some(curr => curr.refQuestionId === prev.refQuestionId))
        .map(item => ({
          ...item,
          isDeleted: true
        }));

      // Combine current and deleted items
      return [...currentWithDeleted, ...deletedItems];
    }

    return currentWithDeleted;
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setHasShownWarning(false); // Reset the warning state when modal closes
    setDeactivateWarningModal(true); // Reset warning modal flag
  };

  useEffect(() => {
    // Filter out countries that are no longer in main selection
    setActiveCountries(prev => 
      prev.filter(activeCountry => 
        selectedCountries.some(mainCountry => mainCountry.countryId === activeCountry.countryId)
      )
    );
    
    setPromptActionCountries(prev => 
      prev.filter(promptCountry =>
        selectedCountries.some(mainCountry => mainCountry.countryId === promptCountry.countryId)
      )
    );

    setMandatoryCountries(prev =>
      prev.filter(mandatoryCountry =>
        selectedCountries.some(mainCountry => mainCountry.countryId === mandatoryCountry.countryId) 
      )
    );

    setAuditCountries(prev =>
      prev.filter(auditCountry =>
        selectedCountries.some(mainCountry => mainCountry.countryId === auditCountry.countryId)
      )
    );
  }, [selectedCountries]);

 useEffect(() => {
    updateTextFieldWidth();
    window.addEventListener('resize', updateTextFieldWidth);
    return () => {
      window.removeEventListener('resize', updateTextFieldWidth);
    };
  }, []);
const updateTextFieldWidth = () => {
    if (textFieldRef.current) {
      setTextFieldWidth(textFieldRef?.current?.node?.offsetWidth);
    }
  };


  const handleModalRowsForStReponseId = (rows) => {
    const data = rows
    const processed = data.map(item => {
      // If stResponseId is missing or falsy (null/undefined/"")
      if (!item.hasOwnProperty('stResponseId') || !item.stResponseId) {
        return {
          ...item,
          stResponseId: generateStaticId()
        };
      }else{
        return item;
      }
    });
    setModalRows(processed)

  }

  const generateStaticId = (() => {
    const usedNumbers = new Set();
  
    return function () {
      let number;
      do {
        number = Math.floor(1000000 + Math.random() * 9000000);
      } while (usedNumbers.has(number));
  
      usedNumbers.add(number);
      return `static${number}`;
    };
  })();
  
  return showAccessDenied ? (
    <AccessDeniedPage />
  ) : (
    <Layout title="Questionare Setup">
      <div className={`Questionnare-setup-container ${
    mode === "newView" ? "disable-select-labels" : ""
  }`} >
        <div
          style={{
            fontWeight: 600,
            fontSize: "1.25rem",
            color: "rgba(115, 125, 134, 1)",
            marginBottom: "1rem",
            paddingLeft: "0.5rem",
          }}
        >
          Edit Questionnaire
         
        </div>
        <Box>
          <Card
            variant="outlined"
            sx={{
              height: "50%",
              borderRadius: "10px",
              paddingTop: "10px",
              padding: "2rem",
              boxShadow: "0px 4px 4px 0px #00000040",
            }}
          >
            <Box sx={{ width: "100%" }}>
              <Grid
                container
                rowSpacing={1}
                columnSpacing={{ xs: 1, sm: 1, md: 0 }}
              >
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                >
                  <InputLabel
                    className="Questionnare-setup-label"
                    required
                    sx={{ width: "10rem" }}
                    htmlFor="my-input"
                  >
                    Crop Year
                  </InputLabel>
                  <TextField
                    select
                    sx={{
    width: "300px",
   ...(mode === "newView" ? transparentDisabledStyle : {}),
  }}
                    disabled={mode == "View" || mode == "Edit" ||mode == "newView"}
                    value={formValues?.cropYear.value}
                    onChange={(e) => handleChange(e)}
                    name="cropYear"
                    error={formValues?.cropYear.error}
                    helperText={
                      formValues?.cropYear.error &&
                      formValues?.cropYear.errorMessage
                    }
                    required
                    variant="outlined"
                    inputRef={textFieldRef}
                  >
                    <MenuItem key={1} value={"Crop Year"}>
                      Crop Year
                    </MenuItem>
                    {cropYears &&
                      cropYears.map((option) => (
                        <MenuItem
                          key={option.cropYearUid}
                          value={option.cropYearUid}
                        >
                          {option.cyCropYear}
                        </MenuItem>
                      ))}
                  </TextField>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                >
                  <InputLabel
                    className="Questionnare-setup-label"
                    required
                    sx={{ width: "10rem" }}
                    htmlFor="my-input"
                  >
                    Crop Stage
                  </InputLabel>
                  <TextField
                    select
                    sx={{ width: "300px", 
                     ...(mode === "newView" ? transparentDisabledStyle : {}),
                    }}
                    disabled={mode == "View" || mode == "Edit" || mode == "newView"}
                    value={formValues?.cropStage.value}
                    onChange={(e) => handleChange(e)}
                    name="cropStage"
                    error={formValues?.cropStage.error}
                    helperText={
                      formValues?.cropStage.error &&
                      formValues?.cropStage.errorMessage
                    }
                    required
                    variant="outlined"
                  >
                    <MenuItem key={1} value={"Crop Stage"}>
                      Crop Stage
                    </MenuItem>
                    {cropStages &&
                      cropStages.map((option) => (
                        <MenuItem
                          key={option.cropStageUid}
                          value={option.cropStageUid}
                        >
                          {option.cropStageName}
                        </MenuItem>
                      ))}
                  </TextField>
                </Grid>
                {mode == "View" ? 
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                >
                  <InputLabel
                    className="Questionnare-setup-label"
                    sx={{ width: "10rem" }}
                    htmlFor="my-input"
                  >
                    Crop Stage Translation
                  </InputLabel>
                  <TextField
                    sx={{ width: "300px" }}
                    value={formValues?.cropStageNameLL.value}
                    onChange={(e) => handleChange(e)}
                    name="cropStageNameLL"
                    error={formValues?.cropStageNameLL.error}
                    helperText={
                      formValues?.cropStageNameLL.error &&
                      formValues?.cropStageNameLL.errorMessage
                    }
                    variant="outlined"
                    disabled={readonlyuser}
                  ></TextField>
                </Grid>
                :""}
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                >
                  <InputLabel
                    className="Questionnare-setup-label"
                    required
                    sx={{ width: "10rem" }}
                    htmlFor="my-input"
                  >
                    Module Name
                  </InputLabel>
                  <TextField
                    select
                    sx={{ width: "300px" ,
                     ...(mode === "newView" ? transparentDisabledStyle : {}),
                    }}
                    disabled={mode == "View" || mode == "Edit" || mode == "newView"}
                    value={formValues?.moduleName.value}
                    onChange={(e) => handleChange(e)}
                    name="moduleName"
                    error={formValues?.moduleName.error}
                    helperText={
                      formValues?.moduleName.error &&
                      formValues?.moduleName.errorMessage
                    }
                    required
                    variant="outlined"
                  >
                    <MenuItem key={1} value={"Module Name"}>
                      Module Name
                    </MenuItem>
                    {modules &&
                      modules.map((option) => (
                        <MenuItem key={option.moduleId} value={option.moduleId}>
                          {option.moduleName}
                        </MenuItem>
                      ))}
                  </TextField>
                </Grid>
                {mode == "View" ? 
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                >
                  <InputLabel
                    className="Questionnare-setup-label"
                    sx={{ width: "10rem" }}
                    htmlFor="my-input"
                  >
                    Module Translation
                  </InputLabel>
                  <TextField
                    sx={{ width: "300px" }}
                    value={formValues?.moduleNameLL?.value}
                    onChange={(e) => handleChange(e)}
                    name="moduleNameLL"
                    error={formValues?.moduleNameLL.error}
                    helperText={
                      formValues?.moduleNameLL.error &&
                      formValues?.moduleNameLL.errorMessage
                    }
                    variant="outlined"
                    disabled={readonlyuser}
                  ></TextField>
                </Grid>
                :""}
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                >
                  <InputLabel
                    className="Questionnare-setup-label"
                    required
                    sx={{ width: "10rem" }}
                    htmlFor="my-input"
                  >
                    Sub Module Name
                  </InputLabel>
                  <TextField
                    select
                    multiple
                    sx={{ width: "300px" ,
                     ...(mode === "newView" ? transparentDisabledStyle : {}),
                    }}
                    disabled={mode == "View" || mode == "Edit" || mode == "newView"}
                    value={formValues?.subModuleName.value}
                    onChange={(e) => handleChange(e)}
                    name="subModuleName"
                    error={formValues?.subModuleName.error}
                    helperText={
                      formValues?.subModuleName.error &&
                      formValues?.subModuleName.errorMessage
                    }
                    required
                    variant="outlined"
                  >
                    <MenuItem key={1} value={"Sub Module Name"}>
                      Sub Module Name
                    </MenuItem>
                    {subModules &&
                      subModules.map((option) => (
                        <MenuItem
                          key={option.subModuleId}
                          value={option.subModuleId}
                        >
                          {option.subModuleName}
                        </MenuItem>
                      ))}
                  </TextField>
                </Grid>
                {mode == "View" ? 
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                >
                  <InputLabel
                    className="Questionnare-setup-label"
                    sx={{ width: "10rem" }}
                    htmlFor="my-input"
                  >
                    Sub Module Translation
                  </InputLabel>
                  <TextField
                    sx={{ width: "300px" }}
                    value={formValues?.subModuleNameLL?.value}
                    onChange={(e) => handleChange(e)}
                    name="subModuleNameLL"
                    error={formValues?.subModuleNameLL.error}
                    helperText={
                      formValues?.subModuleNameLL.error &&
                      formValues?.subModuleNameLL.errorMessage
                    }
                    variant="outlined"
                    disabled={readonlyuser}
                  ></TextField>
                </Grid>
                :""}
               {mode != 'View' &&   <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  sx={{ display: mode === "View" ? "none" : "flex" }}
                >
                  <InputLabel
                    className="Questionnare-setup-label"
                    required
                    sx={{ width: "10rem" }}
                    htmlFor="my-input"
                  >
                    Country
                  </InputLabel>
                  <Select
                    sx={{
    width: textFieldWidth, // Fixed width to match other dropdowns
    '& .MuiSelect-select': {
      // maxWidth: "300px",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    },
    pointerEvents: mode === "newView" ? "auto" : undefined,
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#ccc",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: mode === "newView" ? "#ccc" : undefined,
    },
    "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
      borderColor: mode === "newView" ? "#ccc" : undefined,
    },
  }}
                    disabled={mode == "View" || mode=="newView"}
                    multiple
                    name="country"
                    value={selected}
                    onChange={(e) => handleChangeCountry(e)}
                    renderValue={(selected) => 
                      selected.map((select) => select.countryName).join(", ")
                    }
                    MenuProps={{
                      PaperProps: {
                        style: {
                          maxHeight: 250,
    width: textFieldWidth, // Fixed width to match other dropdowns
                          // maxWidth: "300px", // Match dropdown width
                          overflowY: "auto",
                          overflowX: "hidden" // Prevent horizontal scroll
                        },
                      },
                    }}
                     
                  >
                    <MenuItem value="all">
                      <ListItemIcon>
                        <Checkbox
                          checked={selected.length === countries.length}
                          icon={<img src={CheckboxUntick} />}
                          checkedIcon={<img src={CheckboxTick} />}
                          onChange={() => {
                            // Trigger handleChangeCountry with 'all' value
                            handleChangeCountry({
                              target: {
                                name: 'country',
                                value: 'all'
                              }
                            });
                          }}
                        />
                      </ListItemIcon>
                      <ListItemText primary="Select All" />
                    </MenuItem>
                    {countries.map((option) => (
                      <MenuItem 
                        key={option.countryCode} 
                        value={option}
                      >
                        <ListItemIcon>
                          <Checkbox
                            checked={selected.some(item => item.countryId === option.countryId)}
                            icon={<img src={CheckboxUntick} />}
                            checkedIcon={<img src={CheckboxTick} />}
                            onChange={(e) => {
                              const isCurrentlySelected = selected.some(
                                country => country.countryId === option.countryId
                              );

                              if (isCurrentlySelected) {
                                // Check if country is selected in any dependent dropdown
                                const isUsedInMandatory = mandatoryCountries.some(
                                  country => country.countryId === option.countryId
                                );
                                const isUsedInAudit = auditCountries.some(
                                  country => country.countryId === option.countryId
                                );
                                const isUsedInActive = activeCountries.some(
                                  country => country.countryId === option.countryId
                                );
                                const isUsedInPromptAction = promptActionCountries.some(
                                  country => country.countryId === option.countryId
                                );

                                const usedInDropdowns = [];
                                if (isUsedInMandatory) usedInDropdowns.push("Mandatory");
                                if (isUsedInAudit) usedInDropdowns.push("Audit");
                                if (isUsedInActive) usedInDropdowns.push("Active");
                                if (isUsedInPromptAction) usedInDropdowns.push("Prompt Action");

                                if (usedInDropdowns.length > 0) {
                                  setSeverity("error");
                                  setMessage(`This country is associated with one or more attributes. Please 
deselect the country from the attributes first, then try again.`);
                                  setOpenAlert(true);
                                  return;
                                }

                                // Remove country if not used in dependent dropdowns
                                const newSelection = selected.filter(
                                  country => country.countryId !== option.countryId
                                );
                                setSelected(newSelection);
                                setSelectedCountries(newSelection);
                              } else {
                                // Add country
                                const newSelection = [...selected, option];
                                setSelected(newSelection);
                                setSelectedCountries(newSelection);
                              }
                            }}
                          />
                        </ListItemIcon>
                        <ListItemText primary={option.countryName} />
                      </MenuItem>
                    ))}
                  </Select>
                </Grid> }
              </Grid>
            </Box>
          </Card>
          <Card
            variant="outlined"
            sx={{
              height: "50%",
              borderRadius: "10px",
              paddingTop: "10px",
              padding: "2rem",
              marginTop: "20px",
              boxShadow: "0px 4px 4px 0px #00000040",
            }}
          >
            <Box sx={{ width: "100%" }}>
              <Grid
                container
                rowSpacing={1}
                columnSpacing={{ xs: 1, sm: 1, md: 0 }}
              >
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                >
                  <InputLabel
                    className="Questionnare-setup-label"
                    sx={{ width: "10rem" }}
                    htmlFor="my-input"
                  >
                    Question Code
                  </InputLabel>
                  <TextField
                    sx={{ width: "300px" ,
                      userSelect: mode === "newView" ? "none" : "text",
                       pointerEvents: mode === "newView" ? "none" : "auto",
                        ...(mode === "newView" ? transparentDisabledStyle : {}),
                    }}
                    value={formValues?.questionCode.value || questionCode}
                    onChange={(e) => handleChange(e)}
                    name="questionCode"
                    disabled
                    variant="outlined"
                  ></TextField>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                >
                  <InputLabel
                    className="Questionnare-setup-label"
                    required
                    sx={{ width: "10rem" }}
                    htmlFor="my-input"
                  >
                    Question Type
                  </InputLabel>
                  <TextField
                    select
                    sx={{ width: "300px" ,
                       ...(mode === "newView" ? transparentDisabledStyle : {}),
                    }}
                    disabled={true}
                    value={formValues?.questionType.value}
                    onChange={(e) => handleChange(e)}
                    name="questionType"
                    error={formValues?.questionType.error}
                    helperText={
                      formValues?.questionType.error &&
                      formValues?.questionType.errorMessage
                    }
                    required
                    variant="outlined"
                  >
                    <MenuItem key={1} value={"Question Type"}>
                      Question Type
                    </MenuItem>
                    {pickListData &&
                      pickListData?.EQSTYP?.map((option) => (
                        <MenuItem
                          key={option.pickListId}
                          value={option.pickListId}
                        >
                          {option.pickListDescription}
                        </MenuItem>
                      ))}
                  </TextField>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                >
                  <InputLabel
                    className="Questionnare-setup-label"
                    required
                    sx={{ width: "10rem" }}
                    htmlFor="my-input"
                  >
                    Question Sequence
                  </InputLabel>
                  <TextField
                    sx={{ width: "300px" ,
                      userSelect: mode === "newView" ? "none" : "text",
                       pointerEvents: mode === "newView" ? "none" : "auto",
                      ...(mode === "newView" ? transparentDisabledStyle : {}),}}
                    disabled={mode == "View"|| mode=="newView"}
                    value={
                      formValues?.questionSequence.value || questionSequence
                    }
                    onChange={(e) => handleChange(e)}
                    name="questionSequence"
                    error={formValues?.questionSequence.error}
                    helperText={
                      formValues?.questionSequence.error &&
                      formValues?.questionSequence.errorMessage
                    }
                    required
                    variant="outlined"
                  ></TextField>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                >
                  <InputLabel
                    className="Questionnare-setup-label"
                    required
                    sx={{ width: "10rem" }}
                    htmlFor="my-input"
                  >
                    Response Type
                  </InputLabel>
                  <TextField
                    select
                      sx={{ width: "300px" ,...(mode === "newView" ? transparentDisabledStyle : {}),}}
                    disabled={mode == "View"|| mode=="newView"||readonlyuser}
                    value={formValues?.responseType.value}
                    onClick={(e) => {
                      const selectedDesc = getPickListDescription(
                        "ERSPTYP",
                        formValues?.responseType?.value
                      );
                  
                      if (
                        includesIgnoreCase(selectedDesc, ["Dropdown", "Multi Select Dropdown"]) &&
                        ((mode === "View" || mode==="newView")&& !readonlyuser)
                      ) {
                        e.preventDefault();
                        e.stopPropagation();
                        setOpenModal(true); // Open modal in view-only mode
                      }
                    }}
                    onChange={(e) => {
                      // Allow editing only in Edit mode
                      if (mode === "Edit") {
                        handleChange(e);  // Handle the change as normal
                      }
                    }}
                    name="responseType"
                    error={formValues?.responseType.error}
                    helperText={
                      formValues?.responseType.error &&
                      formValues?.responseType.errorMessage
                    }
                    required
                    variant="outlined"
                  >
                    <MenuItem disabled key={1} value={"Answer Type"}>
                      Answer Type
                    </MenuItem>
                    {pickListData &&
                      pickListData?.ERSPTYP?.map((option) => (
                        <MenuItem
                          key={option.pickListId}
                          value={option.pickListId}
                          disabled={
                            !equalsIgnoreCase(
                              option?.pickListDescription,
                              getPickListDescription(
                                "ERSPTYP",
                                formValues?.responseType?.value
                              )
                            )
                          }
                          onClick={() => {
                            hanldeResponseTypeClick(
                              option.pickListId,
                              option?.pickListDescription
                            );
                          }}
                        >
                          {option.pickListDescription}
                        </MenuItem>
                      ))}
                  </TextField>
                </Grid>
                {includesIgnoreCase(responseType, ["Numeric", "Integer"]) ? (
                  <>
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      md={4}
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <InputLabel
                        className="Questionnare-setup-label"
                        sx={{ width: "10rem" }}
                        htmlFor="my-input"
                      >
                        Minimum Value
                      </InputLabel>
                      <TextField
                        sx={{
                          width: "300px",
                          userSelect: mode === "newView" ? "none" : "text",
                          pointerEvents: mode === "newView" ? "none" : "auto",
                            ...(mode === "newView" ? transparentDisabledStyle : {}),
                          "& input[type=number]": {
                            "-moz-appearance": "textfield",
                          },
                          "& input[type=number]::-webkit-outer-spin-button": {
                            "-webkit-appearance": "none",
                            margin: 0,
                          },
                          "& input[type=number]::-webkit-inner-spin-button": {
                            "-webkit-appearance": "none",
                            margin: 0,
                          },
                        }}
                        value={formValues?.minTolerance?.value}
                        onChange={(e) => {
                          const value = e.target.value;
                          // Remove any + or - signs from the input
                          const sanitizedValue = value.replace(/[+-]/g, '');

                          if (equalsIgnoreCase(responseType, "Integer")) {
                            // Only allow integers (0-9)
                            if (sanitizedValue === '' || /^\d*$/.test(sanitizedValue)) {
                              handleChange({
                                target: {
                                  name: e.target.name,
                                  value: sanitizedValue
                                }
                              });
                            } else {
                              setMessage("Only integer values are allowed");
                              setSeverity("error");
                              setOpenAlert(true);
                            }
                          } else if (equalsIgnoreCase(responseType, "Numeric")) {
                            // Allow decimals (0-9 and decimal point)
                            if (sanitizedValue === '' || /^\d*\.?\d*$/.test(sanitizedValue)) {
                              handleChange({
                                target: {
                                  name: e.target.name,
                                  value: sanitizedValue
                                }
                              });
                            } else {
                              setMessage("Only numeric values are allowed");
                              setSeverity("error");
                              setOpenAlert(true);
                            }
                          }
                        }}
                        name="minTolerance"
                        error={formValues?.minTolerance?.error}
                        helperText={
                          formValues?.minTolerance?.error &&
                          formValues?.minTolerance?.errorMessage
                        }
                        type="text" // Change from "number" to "text" to have more control
                        inputProps={{
                          inputMode: equalsIgnoreCase(responseType, "Integer") ? "numeric" : "decimal",
                          pattern: equalsIgnoreCase(responseType, "Integer") ? "[0-9]*" : "[0-9]*(.[0-9]+)?",
                          style: { textAlign: 'left' }  // Optional: for better number alignment
                        }}
                        variant="outlined"
                        disabled={user?.userAttribute === "Global" || mode=="newView"}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      md={4}
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <InputLabel
                        className="Questionnare-setup-label"
                        sx={{ width: "10rem" }}
                        htmlFor="my-input"
                      >
                        Maximum Value
                      </InputLabel>
                      <TextField
                        sx={{
                          width: "300px",
                           ...(mode === "newView" ? transparentDisabledStyle : {}),
                           userSelect: mode === "newView" ? "none" : "text",
                       pointerEvents: mode === "newView" ? "none" : "auto",
                          "& input[type=number]": {
                            "-moz-appearance": "textfield",
                          },
                          "& input[type=number]::-webkit-outer-spin-button": {
                            "-webkit-appearance": "none",
                            margin: 0,
                          },
                          "& input[type=number]::-webkit-inner-spin-button": {
                            "-webkit-appearance": "none",
                            margin: 0,
                          },
                        }}
                        value={formValues?.maxTolerance?.value}
                        onChange={(e) => {
                          const value = e.target.value;
                          // Remove any + or - signs from the input
                          const sanitizedValue = value.replace(/[+-]/g, '');

                          if (equalsIgnoreCase(responseType, "Integer")) {
                            // Only allow integers (0-9)
                            if (sanitizedValue === '' || /^\d*$/.test(sanitizedValue)) {
                              handleChange({
                                target: {
                                  name: e.target.name,
                                  value: sanitizedValue
                                }
                              });
                            } else {
                              setMessage("Only integer values are allowed");
                              setSeverity("error");
                              setOpenAlert(true);
                            }
                          } else if (equalsIgnoreCase(responseType, "Numeric")) {
                            // Allow decimals (0-9 and decimal point)
                            if (sanitizedValue === '' || /^\d*\.?\d*$/.test(sanitizedValue)) {
                              handleChange({
                                target: {
                                  name: e.target.name,
                                  value: sanitizedValue
                                }
                              });
                            } else {
                              setMessage("Only numeric values are allowed");
                              setSeverity("error");
                              setOpenAlert(true);
                            }
                          }
                        }}
                        name="maxTolerance"
                        error={formValues?.maxTolerance?.error}
                        helperText={
                          formValues?.maxTolerance?.error &&
                          formValues?.maxTolerance?.errorMessage
                        }
                        type="text" // Change from "number" to "text" to have more control
                        inputProps={{
                          inputMode: equalsIgnoreCase(responseType, "Integer") ? "numeric" : "decimal",
                          pattern: equalsIgnoreCase(responseType, "Integer") ? "[0-9]*" : "[0-9]*(.[0-9]+)?",
                          style: { textAlign: 'left' }  // Optional: for better number alignment
                        }}
                        variant="outlined"
                        disabled={user?.userAttribute === "Global" || mode=="newView"}
                      />
                    </Grid>
                  </>
                ) : (
                  ""
                )}
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                >
                  <InputLabel
                    className="Questionnare-setup-label"
                    sx={{ width: "10rem" }}
                    htmlFor="my-input"
                    required={formValues?.validationType?.value !== ""}
                  >
                    Reference question for validation
                  </InputLabel>
                  <TextField
                    select
                    sx={{ width: "300px" , ...(mode === "newView" ? transparentDisabledStyle : {}),}}
                    disabled={
                      !includesIgnoreCase(responseType, ["Numeric", "Integer"]) ||
                      user?.userAttribute === "Local" || mode=="newView"||
                      formValues?.multiInstance?.value === true  // Add this condition
                    }
                    value={formValues?.referenceQuestion?.value || ""}
                    onChange={(e) => handleChange(e)}
                    name="referenceQuestion"
                    error={formValues?.referenceQuestion.error}
                    helperText={
                      formValues?.referenceQuestion.error &&
                      formValues?.referenceQuestion.errorMessage
                    }
                    variant="outlined"
                    SelectProps={{
                      // Preserve default dropdown icon
                      IconComponent: undefined
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          {formValues?.referenceQuestion?.value && !formValues?.multiInstance?.value == true &&  (
                            <IconButton
                              edge="end"
                              onClick={(e) => {
                                e.stopPropagation();
                                setFieldToClear('referenceQuestion');
                                setSurityModalMessage("Are you sure you want to unselect the Reference Question for Validation?");
                                setSurityModalOpen2(true);
                              }}
                              disabled={mode === "View"|| mode=="newView"}
                              sx={{ 
                                visibility: mode === "View" ? 'hidden' : 'visible',
                                padding: '4px',
                                marginRight: '16px', // Add space for dropdown icon
                                '&:hover': {
                                  backgroundColor: 'transparent'
                                }
                              }}
                            >
                              <ClearIcon fontSize="small" />
                            </IconButton>
                          )}
                        </InputAdornment>
                      )
                    }}
                  >
                    {referenceQuestions.map((option) => (
                      <MenuItem key={option.questionId} value={option.questionId}>
                        {option.questionCode}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                >
                  <InputLabel
                    className="Questionnare-setup-label"
                    sx={{ width: "10rem" }}
                    htmlFor="my-input"
                    required={formValues?.referenceQuestion?.value !== ""}
                  >
                    Validation
                  </InputLabel>
                  <TextField
                    select
                    sx={{ 
                      width: "300px",
                       ...(mode === "newView" ? transparentDisabledStyle : {}),
                      '& .MuiSelect-select': {
                        paddingRight: '5px !important'
                      }
                    }}
                    disabled={
                      !includesIgnoreCase(responseType, ["Numeric", "Integer"]) ||
                      user?.userAttribute === "Local" ||
                      formValues?.multiInstance?.value === true  // Add this condition
                      || mode=="newView"
                    }
                    value={formValues?.validationType?.value || ""}
                    onChange={(e) => handleChange(e)}
                    name="validationType"
                    error={formValues?.validationType.error}
                    helperText={
                      formValues?.validationType.error &&
                      formValues?.validationType.errorMessage
                    }
                    variant="outlined"
                    SelectProps={{
                      IconComponent: undefined
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          {formValues?.validationType?.value && !formValues?.multiInstance?.value == true &&  (
                            <IconButton
                              edge="end"
                              onClick={(e) => {
                                e.stopPropagation();
                                setFieldToClear('validationType');
                                setSurityModalMessage("Are you sure you want to unselect the validation?");
                                setSurityModalOpen2(true);
                              }}
                              disabled={mode === "View" || mode=="newView"}
                              sx={{ 
                                visibility: mode === "View" ? 'hidden' : 'visible',
                                padding: '4px',
                                marginRight: '16px',
                                '&:hover': {
                                  backgroundColor: 'transparent'
                                }
                              }}
                            >
                              <ClearIcon fontSize="small" />
                            </IconButton>
                          )}
                        </InputAdornment>
                      )
                    }}
                  >
                    {pickListData?.EQREFQV?.map((option) => (
                      <MenuItem key={option.pickListId} value={option.pickListId}>
                        {option.pickListDescription}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
              </Grid>
            </Box>
          </Card>
          {includesIgnoreCase(getPickListDescription("ERSPTYP", formValues?.responseType?.value), ["Numeric", "Integer"]) &&
            formValues?.multiInstance?.value !== true && (  // Add this condition
              <Card
                variant="outlined"
                sx={{
                  height: "50%",
                  borderRadius: "10px",
                  paddingTop: "10px",
                  padding: "2rem",
                  marginTop: "20px",
                  boxShadow: "0px 4px 4px 0px #00000040",
                }}
              >
                <Box sx={{ width: '100%' }}>
                  <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 4 }}>
                    {/* Calculated Questions Checkbox */}
                    <Grid item xs={12} sm={6} md={4} display="flex" justifyContent="center" alignItems="center">
                      <InputLabel
                        className="Questionnare-setup-label"
                        sx={{ width: "10rem" }}
                      >
                        Calculated Questions
                      </InputLabel>
                      <Box sx={{ width: "300px", display: "flex", justifyContent: "center" }}>
                        <Checkbox
                          checked={calculationFields.isCalculated}
                          onChange={(e) => setCalculationFields(prev => ({
                            ...prev,
                            isCalculated: e.target.checked
                          }))}
                          disabled={mode === "View"|| mode=="newView"}
                        />
                      </Box>
                    </Grid>

                    {/* Reference Questions Multiple Select */}
                    <Grid item xs={12} sm={6} md={8} display="flex" justifyContent="center" alignItems="center">
                      <InputLabel
                        className="Questionnare-setup-label"
                        sx={{ width: "10rem" }}
                      >
                        Reference Question for Calculation
                      </InputLabel>
                      <Select
                        multiple
                        sx={{
    width: "100%",
    overflow:"hidden",
    pointerEvents: mode === "newView" ? "auto" : undefined, // allow hover but keep disabled
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#ccc", // your default border color
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: mode === "newView" ? "#ccc" : undefined,
    },
    "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
      borderColor: mode === "newView" ? "#ccc" : undefined,
    },
  }} // Changed from 100% to 300px to match other fields
                        value={calculationFields.referenceQuestions} // This stays the same
                        onChange={(e) => {
                          const selectedQuestions = e.target.value;
                          // Initialize currentSequenced as empty array if undefined
                          const currentSequenced = calculationFields.sequencedRefQuestions || [];

                          // Handle sequence management
                          let newSequencedQuestions = [];

                          // If a question is deselected, remove it from sequenced array and reorder remaining
                          if (selectedQuestions.length < calculationFields.referenceQuestions.length) {
                            const removedQuestion = calculationFields.referenceQuestions.find(
                              q => !selectedQuestions.some(sq => sq.questionId === q.questionId)
                            );

                            newSequencedQuestions = currentSequenced
                              .filter(sq => sq.refQuestionId !== removedQuestion.questionId)
                              .map((sq, index) => ({
                                ...sq,
                                sequence: index + 1
                              }));
                          }
                          // If a question is added, append it with next sequence number
                          else if (selectedQuestions.length > calculationFields.referenceQuestions.length) {
                            const addedQuestion = selectedQuestions.find(
                              q => !calculationFields.referenceQuestions.some(rq => rq.questionId === q.questionId)
                            );

                            newSequencedQuestions = [
                              ...currentSequenced,
                              {
                                refQuestionId: addedQuestion.questionId,
                                sequence: currentSequenced.length + 1
                              }
                            ];
                          }

                          const newExpression = generateExpression(selectedQuestions, calculationFields.operation);

                          setCalculationFields(prev => ({
                            ...prev,
                            referenceQuestions: selectedQuestions,
                            sequencedRefQuestions: newSequencedQuestions,
                            expression: newExpression,
                            expectedResult: newExpression
                          }));
                        }}
                        disabled={mode === "View" || mode=="newView"}
                        renderValue={(selected) => selected.map(s => s.questionCode).join(', ')} // Modified to only show question codes
                        MenuProps={{
                          PaperProps: {
                            style: {
                              maxWidth: "400px",
                              maxHeight: 250,
                              overflowY: "auto"
                            }
                          }
                        }}
                      >
                        {calculationReferenceQuestions.map((option) => (
                          <MenuItem key={option.questionId} value={option}>
                            <Checkbox
                              checked={calculationFields.referenceQuestions.some(
                                item => item.questionId === option.questionId
                              )}
                              icon={<img src={CheckboxUntick} />}
                              checkedIcon={<img src={CheckboxTick} />}
                            />
                            {/* <ListItemText 
                            primary={`${option.questionCode} - ${option.questionTextEng} ${
                              calculationFields.sequencedRefQuestions.find(
                                sq => sq.refQuestionId === option.questionId
                              )?.sequence ? 
                              `(${calculationFields.sequencedRefQuestions.find(
                                sq => sq.refQuestionId === option.questionId
                              ).sequence})` : 
                              ''
                            }`} 
                          /> */}
                            <ListItemText
                              primary={
                                <div style={{
                                  display: 'flex',
                                  flexDirection: 'column'
                                }}>
                                  <div style={{
                                    display: 'flex',
                                    alignItems: 'flex-start',
                                    gap: '4px'
                                  }}>
                                    <span style={{ fontWeight: '', whiteSpace: 'nowrap' }}>
                                      {calculationFields?.sequencedRefQuestions?.find(
                                        sq => sq.refQuestionId === option.questionId
                                      )?.sequence ?
                                        ` (${calculationFields?.sequencedRefQuestions?.find(
                                          sq => sq.refQuestionId === option.questionId
                                        ).sequence})` :
                                        ''
                                      }
                                      {option.questionCode}
                                    </span>
                                    <span style={{
                                      color: '#666',
                                      wordBreak: 'break-word',
                                      whiteSpace: 'normal'
                                    }}>
                                      - {option.questionTextEng}
                                    </span>
                                  </div>
                                </div>
                              }
                              sx={{
                                '& .MuiTypography-root': {
                                  whiteSpace: 'normal',
                                  wordWrap: 'break-word'
                                }
                              }}
                            />
                          </MenuItem>
                        ))}
                      </Select>
                    </Grid>

                    {/* Calculation Operation Dropdown */}
                    <Grid item xs={12} sm={6} md={4} display="flex" justifyContent="center" alignItems="center">
                      <InputLabel
                        className="Questionnare-setup-label"
                        sx={{ width: "10rem" }}
                      >
                        Calculation Operation
                      </InputLabel>
                      <TextField
                        select
                        sx={{ width: "300px" , ...(mode === "newView" ? transparentDisabledStyle : {}), }}
                        value={calculationFields.operation}
                        onChange={(e) => {
                          const newOperation = e.target.value;
                          const newExpression = generateExpression(calculationFields.referenceQuestions, newOperation);
                          setCalculationFields(prev => ({
                            ...prev,
                            operation: newOperation,
                            expression: newExpression,
                            expectedResult: newExpression // Auto-populate the expected result
                          }));
                        }}
                        disabled={mode === "View" || mode === "newView"}
                      >
                        <MenuItem value="" disabled>
                          Calculated Operation
                        </MenuItem>
                        {calculationOperations.map((op) => (
                          <MenuItem key={op.id} value={op.id}>
                            {op.label}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>

                    {/* Expected Result TextField */}
                    <Grid item xs={12} sm={6} md={8} display="flex" justifyContent="center" alignItems="center">
                      <InputLabel
                        className="Questionnare-setup-label"
                        sx={{ width: "10rem" }}
                      >
                        Expected Result
                      </InputLabel>
                      <TextField
                        sx={{
                          width: "100%",
                           ...(mode === "newView" ? transparentDisabledStyle : {}),
                          '& .MuiInputBase-input': {
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                          }
                        }}
                        value={calculationFields.expectedResult}
                        onChange={(e) => setCalculationFields(prev => ({
                          ...prev,
                          expectedResult: e.target.value
                        }))}
                        disabled={mode === "View" || mode=="newView"}
                        placeholder=""
                        inputProps={{
                          readOnly: true,
                        }}
                        // Add Tooltip wrapper
                       InputProps={{
    title: mode !== "newView" ? calculationFields.expectedResult : undefined,
    'data-placement': 'top',
    style: {
      position: 'relative',
    },
    onMouseEnter:
      mode !== "newView"
        ? (e) => {
            const tooltip = e.currentTarget.title;
            if (tooltip) {
              e.currentTarget.setAttribute("data-tooltip-calculation", tooltip);
              e.currentTarget.removeAttribute("title");
            }
          }
        : undefined,
    onMouseLeave:
      mode !== "newView"
        ? (e) => {
            const tooltip = e.currentTarget.getAttribute("data-tooltip-calculation");
            if (tooltip) {
              e.currentTarget.setAttribute("title", tooltip);
              e.currentTarget.removeAttribute("data-tooltip-calculation");
            }
          }
        : undefined,
  }}
                      />
                    </Grid>
                  </Grid>
                </Box>
              </Card>
            )}
          <Card
            variant="outlined"
            sx={{
              height: "50%",
              borderRadius: "10px",
              paddingTop: "10px",
              padding: "2rem",
              marginTop: "20px",
              boxShadow: "0px 4px 4px 0px #00000040",
            }}
          >
           <Box sx={{ width: "100%" }}>
  <Grid container sx={{paddingLeft: "8px"}}>
    {/* Single row for all checkboxes */}
    <Grid 
      item 
      container 
      xs={12} 
      sx={{
        px: 0, // Add horizontal padding to align with upper card
        '& .MuiGrid-item': {
          px: '40px', // Add more space between items
          pl:'20px' // Add left padding to align with upper card
        }
      }}
    >
      {/* Pre Populated */}
      <Grid 
        item 
        xs={12} 
        sm={6} 
        md={2.4}
        sx={{
          pl: '0px !important' // Remove left padding from first item
        }}
      >
        <Box sx={{ 
          display: "flex", 
          alignItems: "center",
          justifyContent: "space-between"
        }}>
          <InputLabel sx={{ width: "10rem" }}>Pre Populated</InputLabel>
          <Checkbox
            disabled={mode == "View" || mode=="newView"}
            name="isPrePopulated"
            checked={formValues?.isPrePopulated?.value == true}
            onChange={(e) => handlePrepopulated(e)}
            sx={mode === "newView" ? transparentDisabledStyle : {}}
          />
        </Box>
      </Grid>

      {/* Other grid items remain the same but with additional right spacing */}
      <Grid item xs={12} sm={6} md={2.4}>
        {/* Mandatory */}
        <Box sx={{ display: "flex", flexDirection: "column", display: mode === "View" ? "none" : "flex" }}>
          <Box sx={{ display: "flex", alignItems: "center",justifyContent: "space-between" }}>
            <InputLabel sx={{ width: "10rem" }}>Mandatory</InputLabel>
            <Checkbox
              disabled={mode == "View" || mode=="newView"}
              name="mandatory"
              checked={formValues?.mandatory?.value == true}
              onChange={(e) => handleChange(e)}
              sx={mode === "newView" ? transparentDisabledStyle : {}}
            />
          </Box>
          {mode != 'View' &&   <Select
              multiple
              value={mandatoryCountries}
              onChange={handleMandatoryCountryChange}
              disabled={!formValues?.mandatory?.value || mode === "View" || mode==="newView"}
              renderValue={(selected) => selected.map(country => country.countryName).join(", ")}
              sx={{ width: "100%", mt: 1 }}
              displayEmpty
              error={formValues?.mandatory?.value && mandatoryCountries.length === 0}
              required={formValues?.mandatory?.value}
            >
              <MenuItem value="all">
                <ListItemIcon>
                  <Checkbox
                    checked={mandatoryCountries.length === selectedCountries.length}
                    icon={<img src={CheckboxUntick} />}
                    checkedIcon={<img src={CheckboxTick} />}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setMandatoryCountries([...selectedCountries]);
                      } else {
                        setMandatoryCountries([]);
                      }
                    }}
                  />
                </ListItemIcon>
                <ListItemText primary="Select All" />
              </MenuItem>
              {selectedCountries.map((country) => (
                <MenuItem key={country.countryId} value={country}>
                  <Checkbox
                    checked={mandatoryCountries.some(
                      item => item.countryId === country.countryId
                    )}
                    icon={<img src={CheckboxUntick} />}
                    checkedIcon={<img src={CheckboxTick} />}
                  />
                  <ListItemText primary={country.countryName} />
                </MenuItem>
              ))}
            </Select> }
        </Box>
      </Grid>

      <Grid item xs={12} sm={6} md={2.4}>
        {/* Audit */}
        <Box sx={{ display: "flex", flexDirection: "column", display: mode === "View" ? "none" : "flex" }}>
          <Box sx={{ display: "flex", alignItems: "center" ,justifyContent: "space-between"}}>
            <InputLabel sx={{ width: "10rem" }}>Audit</InputLabel>
            <Checkbox
              disabled={mode == "View" || mode=="newView" || formValues?.active?.value == false}
              name="audit"
              checked={formValues?.audit?.value == true}
              onChange={(e) => handleChange(e)}
              sx={mode === "newView" ? transparentDisabledStyle : {}}
            />
          </Box>
          {mode != 'View' &&   <Select
              multiple
              value={auditCountries}
              onChange={handleAuditCountryChange}
              disabled={!formValues?.audit?.value || mode === "View" || mode==="newView"}
              renderValue={(selected) => selected.map(country => country.countryName).join(", ")}
              sx={{ width: "100%", mt: 1 }}
              displayEmpty
              error={formValues?.audit?.value && auditCountries.length === 0}
              required={formValues?.audit?.value}
            >
              <MenuItem value="all">
                <ListItemIcon>
                  <Checkbox
                    checked={auditCountries.length === selectedCountries.length}
                    icon={<img src={CheckboxUntick} />}
                    checkedIcon={<img src={CheckboxTick} />}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setAuditCountries([...selectedCountries]);
                      } else {
                        setAuditCountries([]);
                      }
                    }}
                  />
                </ListItemIcon>
                <ListItemText primary="Select All" />
              </MenuItem>
              {selectedCountries.map((country) => (
                <MenuItem key={country.countryId} value={country}>
                  <Checkbox
                    checked={auditCountries.some(
                      item => item.countryId === country.countryId
                    )}
                    icon={<img src={CheckboxUntick} />}
                    checkedIcon={<img src={CheckboxTick} />}
                  />
                  <ListItemText primary={country.countryName} />
                </MenuItem>
              ))}
            </Select> }
        </Box>
      </Grid>

      <Grid item xs={12} sm={6} md={2.4}>
        {/* Active */}
        <Box sx={{ display: "flex", flexDirection: "column", display: mode === "View" ? "none" : "flex" }}>
          <Box sx={{ display: "flex", alignItems: "center",justifyContent: "space-between" }}>
            <InputLabel sx={{ width: "10rem" }}>Active</InputLabel>
            <Checkbox
              disabled={mode == "View" || mode=="newView"}
              name="active"
              checked={formValues?.active?.value == true}
              onChange={(e) => handleChange(e)}
              sx={mode === "newView" ? transparentDisabledStyle : {}}
            />
          </Box>
          {mode != 'View' &&    <Select
              multiple
              value={activeCountries}
              onChange={handleActiveCountryChange}
              disabled={!formValues?.active?.value || mode === "View" || mode==="newView"}
              renderValue={(selected) => selected.map(country => country.countryName).join(", ")}
              sx={{ width: "100%", mt: 1 }}
              displayEmpty
              error={formValues?.active?.value && activeCountries.length === 0}
              required={formValues?.active?.value}
            >
              <MenuItem value="all">
                <ListItemIcon>
                  <Checkbox
                    checked={activeCountries.length === selectedCountries.length}
                    icon={<img src={CheckboxUntick} />}
                    checkedIcon={<img src={CheckboxTick} />}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setActiveCountries([...selectedCountries]);
                      } else {
                        setActiveCountries([]);
                      }
                    }}
                  />
                </ListItemIcon>
                <ListItemText primary="Select All" />
              </MenuItem>
              {selectedCountries.map((country) => (
                <MenuItem key={country.countryId} value={country}>
                  <Checkbox
                    checked={activeCountries.some(
                      item => item.countryId === country.countryId
                    )}
                    icon={<img src={CheckboxUntick} />}
                    checkedIcon={<img src={CheckboxTick} />}
                  />
                  <ListItemText primary={country.countryName} />
                </MenuItem>
              ))}
            </Select>}
        </Box> 
      </Grid>

      {/* Multi Instance - Last item */}
      {isMultiSelect && (
        <Grid 
          item 
          xs={12} 
          sm={6} 
          md={2.4}
          sx={{
            pr: '0px !important' // Remove right padding from last item
          }}
        >
          <Box sx={{ 
            display: "flex", 
            alignItems: "center",
            justifyContent: "space-between"
          }}>
            <InputLabel sx={{ width: "10rem" }}>Multi Instance</InputLabel>
            <Checkbox
              disabled={mode == "View" || mode=="newView"}
              name="multiInstance"
              checked={formValues?.multiInstance?.value == true}
              onChange={(e) => handleChange(e)}
              sx={mode === "newView" ? transparentDisabledStyle : {}}
            />
          </Box>
        </Grid>
      )}
    </Grid>
  </Grid>
</Box>
          </Card>
          <Card
            variant="outlined"
            sx={{
              height: "50%",
              borderRadius: "10px",
              paddingTop: "10px",
              padding: "2rem",
              marginTop: "20px",
              boxShadow: "0px 4px 4px 0px #00000040",
            }}
          >
            <Box sx={{ width: "100%" }}>
              <Grid
                container
                rowSpacing={1}
                columnSpacing={{ xs: 1, sm: 1, md: 0 }}
              >
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                >
                  <InputLabel
                    className="Questionnare-setup-label"
                    required={promptMandatory}
                    sx={{ width: "10rem" }}
                    htmlFor="my-input"
                  >
                    Prompt Action
                  </InputLabel>
                  <TextField
                    select
                    sx={{ width: "300px" , ...(mode === "newView" ? transparentDisabledStyle : {}),}}
                    disabled={!promptMandatory || mode == "View"|| mode=="newView"}
                    value={formValues.promptAction.value}
                    onChange={(e) => handleChange(e)}
                    name="promptAction"
                    error={formValues?.promptAction.error}
                    helperText={
                      formValues?.promptAction.error &&
                      formValues?.promptAction.errorMessage
                    }
                    required
                    variant="outlined"
                  >
                    {/* <MenuItem key={1} value={"Prompt Action"}>
                      Prompt Action
                    </MenuItem> */}
                    {pickListData &&
                      pickListData?.EQPACT?.map((option) => (
                        <MenuItem
                          key={option.pickListId}
                          value={option.pickListId}
                        >
                          {option.pickListDescription}
                        </MenuItem>
                      ))}
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={6} md={4} display="flex" justifyContent="center" alignItems="center" sx={{ display: mode === "View" ? "none" : "flex" }}>
  <InputLabel
    className="Questionnare-setup-label"
    required
    sx={{ width: "10rem" }}
    htmlFor="my-input"
  >
    Countries Prompt Action
  </InputLabel>
  <Box sx={{ mt: 1 }}>
    <Select
      multiple
      disabled={
        mode === "View" ||
        mode==="newView" ||
        equalsIgnoreCase(getPickListDescription("EQPACT", formValues?.promptAction?.value), "No")
      }
      value={promptActionCountries}
      onChange={handlePromptActionCountryChange}
      renderValue={(selected) => 
        selected.map(country => country.countryName).join(", ")
      }
      MenuProps={{
        PaperProps: {
          style: {
            maxHeight: 250,
            overflowY: "auto",
          },
        },
      }}
      sx={{ 
        width: "300px",
        '& .MuiSelect-select': {
          maxWidth: "300px",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        }
      }}
      error={
        !equalsIgnoreCase(getPickListDescription("EQPACT", formValues?.promptAction?.value), "No") &&
        promptActionCountries.length === 0
      }
      required={!equalsIgnoreCase(getPickListDescription("EQPACT", formValues?.promptAction?.value), "No")}
    >
      <MenuItem value="all">
        <ListItemIcon>
          <Checkbox
            checked={promptActionCountries.length === selectedCountries.length}
            icon={<img src={CheckboxUntick} />}
            checkedIcon={<img src={CheckboxTick} />}
            onChange={(e) => {
              if (e.target.checked) {
                setPromptActionCountries([...selectedCountries]);
              } else {
                setPromptActionCountries([]);
              }
            }}
          />
        </ListItemIcon>
        <ListItemText primary="Select All" />
      </MenuItem>
      {selectedCountries.map((country) => (
        <MenuItem key={country.countryId} value={country}>
          <ListItemIcon>
            <Checkbox
              checked={promptActionCountries.some(
                (selected) => selected.countryId === country.countryId
              )}
              icon={<img src={CheckboxUntick} />}
              checkedIcon={<img src={CheckboxTick} />}
            />
          </ListItemIcon>
          <ListItemText primary={country.countryName} />
        </MenuItem>
      ))}
    </Select>
  </Box>
</Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                >
                  <InputLabel
                    className="Questionnare-setup-label"
                    required={promptMandatory}
                    sx={{ width: "10rem" }}
                    htmlFor="my-input"
                  >
                    Prompt Action Response Condition
                  </InputLabel>
                  <TextField
                    select
                    sx={{ width: "300px", ...(mode === "newView" ? transparentDisabledStyle : {}), }}
                    disabled={mode == "View" || mode=="newView"}
                    value={formValues?.promptActionReponseCondition.value}
                    onChange={(e) => handleChange(e)}
                    name="promptActionReponseCondition"
                    error={formValues?.promptActionReponseCondition.error}
                    helperText={
                      formValues?.promptActionReponseCondition.error &&
                      formValues?.promptActionReponseCondition.errorMessage
                    }
                    required
                    variant="outlined"
                  >
                    <MenuItem key={1} value={"Select Condition"}>
                      Select Condition
                    </MenuItem>
                    {pickListData &&
                      pickListData?.ERSPCON?.map((option) => (
                        <MenuItem
                          key={option.pickListId}
                          value={option.pickListId}
                        >
                          {option.pickListDescription}
                        </MenuItem>
                      ))}
                  </TextField>
                </Grid>
                
                <Grid
  item
  xs={12}
  sm={6}
  md={4}
  display="flex"
  justifyContent="center"
  alignItems="center"
>
  <InputLabel
    className="Questionnare-setup-label"
    required={promptMandatory}
    sx={{ width: "10rem" }}
    htmlFor="promptActionReponseValue"
  >
    Prompt Action Response Value
  </InputLabel>

  {includesIgnoreCase(responseType, ["Dropdown", "Multi Select Dropdown"]) ? (
    <Autocomplete
      multiple
      disableCloseOnSelect
      disabled={mode === "View" || mode==="newView"}
      options={modalRows || []}
      getOptionLabel={(option) => option.name}
      value={modalRows?.filter(row => 
        formValues?.promptActionReponseValue?.value
          ?.split('|')
          ?.includes(row.stResponseId)
      ) || []}
      onChange={(event, newValues) => {
        const selectedIds = newValues.map(v => v.stResponseId);
        const syntheticEvent = {
          target: {
            name: 'promptActionReponseValue',
            value: selectedIds.join('|')
          }
        };
        handleChange(syntheticEvent);
      }}
      renderTags={(selected, getTagProps) => (
        <span >
          {selected.map(s => s.name).join('\u200B|')}
        </span>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          sx={{ 
            width: "300px",
            ...(mode === "newView" ? transparentDisabledStyle : {}),
            '& .MuiOutlinedInput-root': {
              '& input': { padding: '8px 14px' },
              '& .MuiAutocomplete-input': { padding: '8px 14px !important' },
              '& .MuiAutocomplete-endAdornment': { right: '8px' }
            },
            '& .MuiOutlinedInput-input': { padding: '8px 14px' },
            '& .MuiAutocomplete-tag': {
              margin: '3px',
              padding: '0 8px'
            }
          }}
          variant="outlined"
          error={formValues?.promptActionReponseValue.error}
          helperText={
            formValues?.promptActionReponseValue.error &&
            formValues?.promptActionReponseValue.errorMessage
          }
          placeholder={!formValues?.promptActionReponseValue?.value ? "Select Response" : ""}
        />
      )}
      renderOption={(props, option, { selected }) => (
        <MenuItem {...props}>
          <ListItemText primary={option.name} />
        </MenuItem>
      )}
    />
  ) : equalsIgnoreCase(responseType, "Radio Button (Yes / No)") ? (
    <FormControl sx={{ width: "300px",
      ...(mode === "newView" ? transparentDisabledStyle : {}), 
     }} 
     variant="outlined" error={formValues?.promptActionReponseValue.error}>
      <Select
        disabled={mode === "View" || mode==="newView"}
        value={formValues?.promptActionReponseValue.value || ""}
        onChange={(e) => handleChange(e)}
        name="promptActionReponseValue"
        displayEmpty
      >
        <MenuItem value="" disabled>
          <em>Select Response</em>
        </MenuItem>
        <MenuItem value="YES">Yes</MenuItem>
        <MenuItem value="NO">No</MenuItem>
      </Select>
      {formValues?.promptActionReponseValue.error && (
        <FormHelperText>{formValues?.promptActionReponseValue.errorMessage}</FormHelperText>
      )}
    </FormControl>
  ) : (
    <TextField
      sx={{ width: "300px",
        ...(mode === "newView" ? transparentDisabledStyle : {}),
       }}
      disabled={mode === "View"|| mode==="newView"}
      value={formValues?.promptActionReponseValue.value}
      onChange={(e) => handleChange(e)}
      name="promptActionReponseValue"
      error={formValues?.promptActionReponseValue.error}
      helperText={formValues?.promptActionReponseValue.error && formValues?.promptActionReponseValue.errorMessage}
      variant="outlined"
    />
  )}
</Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                >
                  <InputLabel
                    className="Questionnare-setup-label"
                    // required={parentMandatory}
                    sx={{ width: "10rem" }}
                    htmlFor="my-input"
                  >
                    Parent Question
                  </InputLabel>
                  <TextField
                    disabled
                    name="parentQuestion"
                    sx={{ width: "300px", ...(mode === "newView" ? transparentDisabledStyle : {}), }}
                    value={formValues?.parentQuestion?.value ? parentCode : ""}
                    variant="outlined"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          {loading ? (
                            <CircularProgress color="inherit" size={20} />
                          ) : (
                            <SearchIcon />
                          )}
                        </InputAdornment>
                      ),
                    }}
                    error={formValues.parentQuestion.error}
                    helperText={
                      formValues.parentQuestion.error &&
                      formValues.parentQuestion.errorMessage
                    }
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                >
                  <InputLabel
                    className="Questionnare-setup-label"
                    required={parentMandatory}
                    sx={{ width: "10rem" }}
                    htmlFor="my-input"
                  >
                    Parent Condition
                  </InputLabel>
                  <TextField
                    select
                    sx={{ width: "300px" , ...(mode === "newView" ? transparentDisabledStyle : {}),}}
                    disabled={mode == "View" || parentMandatory == false || mode=="newView"}
                    value={formValues?.parentCondition.value}
                    onChange={(e) => handleChange(e)}
                    name="parentCondition"
                    error={formValues?.parentCondition.error}
                    helperText={
                      formValues?.parentCondition.error &&
                      formValues?.parentCondition.errorMessage
                    }
                    required
                    variant="outlined"
                  >
                    <MenuItem key={1} value={"Select Parent Condition"}>
                      Select Parent Condition
                    </MenuItem>
                    {pickListData &&
                      pickListData?.ERSPCON?.map((option) => (
                        <MenuItem
                          key={option.pickListId}
                          value={option.pickListId}
                        >
                          {option.pickListDescription}
                        </MenuItem>
                      ))}
                  </TextField>
                </Grid>
                <Grid
  item
  xs={12}
  sm={6}
  md={4}
  display="flex"
  justifyContent="center"
  alignItems="center"
>
  <InputLabel
    className="Questionnare-setup-label"
    required={parentMandatory}
    sx={{ width: "10rem" }}
  >
    Parent Response Value
  </InputLabel>

  {/* Multi Select Dropdown */}
  {includesIgnoreCase(selectedParentOption?.responseType, ["Dropdown", "Multi Select Dropdown"]) && (
    <Autocomplete
      multiple
      disableCloseOnSelect
      disabled={mode === "View" || mode==="newView"}
      options={parentResponseOptions}
      getOptionLabel={(option) => option.parentResponseText}
      value={parentResponseOptions.filter(opt =>
        formValues.parentReponseValue.value
          ?.split('|')
          .includes(opt.parentResponseText)
      )}
      onChange={(event, newValues) => {
        const selectedTexts = newValues.map(v => v.parentResponseText);
        setFormValues({
          ...formValues,
          parentReponseValue: {
            value: selectedTexts.join('|'),
            error: parentMandatory && selectedTexts.length === 0,
            errorMessage: "You must provide parent response",
          },
        });
      }}
      renderTags={(selected) => (
        <span>
          {selected.map(s => s.parentResponseText).join('\u200B|')}
        </span>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          sx={{ width: "300px" ,
            ...(mode === "newView" ? transparentDisabledStyle : {}),
          }}
          variant="outlined"
          error={formValues.parentReponseValue.error}
          helperText={
            formValues.parentReponseValue.error &&
            formValues.parentReponseValue.errorMessage
          }
        />
      )}
    />
  )}

  {/* Single Select Dropdown */}
  {(
  
    equalsIgnoreCase(selectedParentOption?.responseType, "Radio Button (Yes / No)")) && (
    <TextField
      select
      sx={{ width: "300px",
        ...(mode === "newView" ? transparentDisabledStyle : {}),
      }}
      disabled={mode === "View" || parentMandatory === false ||mode==="newView"}
      value={formValues.parentReponseValue.value || ""}
      onChange={(e) =>
        setFormValues({
          ...formValues,
          parentReponseValue: {
            value: e.target.value,
            error: parentMandatory && e.target.value === "",
            errorMessage: "You must provide parent response",
          },
        })
      }
      error={formValues.parentReponseValue.error}
      helperText={
        formValues.parentReponseValue.error &&
        formValues.parentReponseValue.errorMessage
      }
      variant="outlined"
    >
      {parentResponseOptions.map((option, index) => (
        <MenuItem key={index} value={option.parentResponseText}>
          {option.parentResponseText}
        </MenuItem>
      ))}
    </TextField>
  )}


  {/* Text Input */}
  {!includesIgnoreCase(selectedParentOption?.responseType, ["Dropdown", "Multi Select Dropdown", "Radio Button (Yes / No)"]) && (
    <TextField
      sx={{ width: "300px",
        ...(mode === "newView" ? transparentDisabledStyle : {}),
       }}
      disabled={mode === "View" || parentMandatory === false|| mode==="newView"}
      value={formValues.parentReponseValue.value || ""}
      onChange={(e) =>
        setFormValues({
          ...formValues,
          parentReponseValue: {
            value: e.target.value,
            error: parentMandatory && e.target.value === "",
            errorMessage: "You must provide parent response",
          },
        })
      }
      error={formValues.parentReponseValue.error}
      helperText={
        formValues.parentReponseValue.error &&
        formValues.parentReponseValue.errorMessage
      }
      variant="outlined"
    />
  )}
</Grid>
                <Grid
                  item
                  xs={12}
                  sm={mode == "View" ? 6:12}
                  md={mode == "View" ? 6:12}
                  display="flex"
                  alignItems="center"
                >
                  <InputLabel
                    className="Questionnare-setup-label"
                    required
                    sx={{
                      width: "10rem",
                      justifyContent: "right",
                      display: "flex",
                    }}
                    htmlFor="my-input"
                  >
                    Question Text
                  </InputLabel>
                  <TextField
                    disabled={mode == "View" || mode=="newView"}
                    onChange={(e) => handleChange(e)}
                    name="questionText"
                    value={formValues?.questionText.value}
                    className="Questionare-setup-textarea"
                    placeholder="Type here.."
                    sx={{ 
                      userSelect: mode === "newView" ? "none" : "text",
                      //pointerEvents: mode === "newView" ? "none" : "auto",
                      ...(mode === "newView" ? transparentDisabledStyle : {}),}}
                    multiline
                    rows={3}
                    variant="outlined"
                    error={formValues.questionText.error}
                    helperText={
                      formValues.questionText.error &&
                      formValues.questionText.errorMessage
                    }
                  />
                </Grid>
                {mode == "View" ? 
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={6}
                  display="flex"
                  alignItems="center"
                >
                  <InputLabel
                    className="Questionnare-setup-label"
                    sx={{
                      width: "10rem",
                      justifyContent: "right",
                      display: "flex",
                    }}
                    htmlFor="my-input"
                  >
                    Question Translation
                  </InputLabel>
                  <TextField
                    onChange={(e) => handleChange(e)}
                    name="questionTextLL"
                    value={formValues?.questionTextLL.value}
                    className="Questionare-setup-textarea"
                    placeholder="Type here.."
                    multiline
                    rows={3}
                    variant="outlined"
                    error={formValues.questionTextLL.error}
                    disabled={readonlyuser}
                    helperText={
                      formValues.questionTextLL.error &&
                      formValues.questionTextLL.errorMessage
                    }
                  />
                </Grid>
:""}

              </Grid>
              <Grid
                container
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "20px",
                  paddingTop: "40px",
                }}
              >
                {readonlyuser||mode === "newView" ? (
    <Button
      disabled={loading}
      style={{ backgroundColor: "#737D86", minWidth: "130px", minHeight:"54px",borderRadius:"10px",
        fontWeight:"600",fontFamily:"Montserrat" }}
      variant="contained"
      type="button"
      onClick={() => navigate("/QuestionnaireSetup")}
    >
      {loading && <CircularProgress size={20} />}
      BACK
    </Button>
  ) :
                mode == "View" ? (
                  <>
                    {" "}
                    <Button
                      disabled={loading}
                      style={{ backgroundColor: "#112A63", minWidth: "92px" }}
                      variant="contained"
                      type="button"
                      onClick={(e) => navigate("/QuestionnaireSetup")}
                    >
                      {loading && <CircularProgress size={20} />}
                      BACK
                    </Button>{" "}
                      <Button
                        disabled={loading}
                        style={{ backgroundColor: "#EF7D00", minWidth: "92px" }}
                        variant="contained"
                        type="button"
                        onClick={(e) => handleSubmit(e,  false)}
                      >
                        {loading && <CircularProgress size={20} />}
                        UPDATE
                      </Button>

                  </>
                ) : (
                  <>
                    <Button
                      disabled={loading}
                      style={{ backgroundColor: "#737D86", minWidth: "92px" }}
                      variant="contained"
                      onClick={() => navigate("/QuestionnaireSetup")}
                    >
                      {" "}
                      {"CANCEL"}
                    </Button>
                    <Button
                      disabled={loading}
                      style={{ backgroundColor: "#112A63", minWidth: "92px" }}
                      variant="contained"
                      type="button"
                      onClick={(e) => handleSubmit(e, false)}
                    >
                      {loading && <CircularProgress size={20} />}
                      {location?.state?.mode == "Edit" ? "UPDATE" : "SAVE"}
                    </Button>
                    <Button
                      disabled={loading}
                      style={{ backgroundColor: "#EF7D00", minWidth: "92px" }}
                      variant="contained"
                      type="button"
                      onClick={(e) => handleSubmit(e, true)}
                    >
                      {loading && <CircularProgress size={20} />}
                      {"PUBLISH"}
                    </Button>
                  </>
                )}
              </Grid>
            </Box>
          </Card>
        </Box>
      </div>
      <DropdownModal
       desc={responseType}
        isGlobalUser={isGlobalUser}
        loading={loading}
        modalRows={modalRows}
        questionCode={formValues?.questionCode.value}
        setModalRows={(rows) => {
          // Allow changes only in Edit mode
          if (mode === "Edit" || mode === "View") {
            handleModalRowsForStReponseId(rows)
          }
        }}
        open={openModal}
        onClose={handleCloseModal} // Use the new handler
        readOnly={mode === "View" || mode == "newView"} 
        mode={mode} 
        setDeactivateWarningModal={() => {
          setDeactivateWarningModal(false);
          setHasShownWarning(true);
        }}
        deactivateWarningModal={deactivateWarningModal && !hasShownWarning} // Only show if not shown before
      />
      <SurityModal
        message={surityModalMessage}
        iconName={Warning}
        loading={loading}
        string={"string"}
        singleButton={true} // Add this prop
        onNext={() => {
          // handleSubmit();
        }}
        open={surityModalOpen}
        onClose={() => {
          setSurityModalOpen(false);
        }}
      />
       <SurityModal
        message={surityModalMessage}
        iconName={warningIcon?.src}
        loading={loading}
        string={"string"}
        singleButton={false}
        onNext={() => {
          if (fieldToClear) {
            handleChange({
              target: {
                name: fieldToClear,
                value: ''
              }
            });
          }
          setSurityModalOpen2(false);
          setFieldToClear(null);
        }}
        open={surityModalOpen2}
        onClose={() => {
          setSurityModalOpen2(false);
          setFieldToClear(null);
        }}
      />
      <AuditConfirmModal
        questionType={questionType}
        activeQuestion={activeQuestion}
        open={openAuditConfirmModal}
        onClose={() => setOpenAuditConfirmModal(false)}
        onConfirm={()=>{
          handleChange(auditEvent)
          setOpenAuditConfirmModal(false)
        }}/>
    </Layout>
  );
};

export default QuestionnareEdit;
